;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="262f43da-e1e1-43c7-833d-b1de405e4e07",e._sentryDebugIdIdentifier="sentry-dbid-262f43da-e1e1-43c7-833d-b1de405e4e07")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5268],{

/***/ 97501:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '1.0.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return base64;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));


/***/ }),

/***/ 9899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_schemaorg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45363);







var WORDS_LIMIT = 20;
/**
 * Breadcrumbs component. Displays a list of links to navigate between pages.
 */ var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, className = param.className, dataTest = param.dataTest, isLoading = param.isLoading;
    var generateItemList = function(breadcrumbs) {
        var schema = [];
        breadcrumbs.forEach(function(item, index) {
            schema.push({
                "@type": "ListItem",
                position: index + 1,
                name: item.element,
                item: item.href
            });
        });
        return schema;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,react_schemaorg__WEBPACK_IMPORTED_MODULE_5__/* .jsonLdScriptProps */ .h6)({
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    itemListElement: generateItemList(breadcrumbs)
                })))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "data-test": "breadcrumbs-section",
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "flex h-[34px] items-center gap-1 py-2 text-xs text-text-secondary"),
                children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "h-5 w-1/3 animate-pulse rounded-sm bg-grey-600 opacity-40")
                }) : breadcrumbs.map(function(param, index) {
                    var element = param.element, href = param.href, as = param.as;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                        children: [
                            index === breadcrumbs.length - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "truncate text-primary-main",
                                "data-test": dataTest,
                                children: element
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: href,
                                as: as,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    "data-test": dataTest,
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("whitespace-nowrap", element.length > WORDS_LIMIT ? "truncate" : ""),
                                    children: element
                                })
                            }, index),
                            index < breadcrumbs.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-secondary-700",
                                "data-test": dataTest,
                                children: "/"
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 22478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var Html = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        dangerouslySetInnerHTML: {
            __html: children
        }
    }, restProps), {
        ref: ref
    }));
});
Html.displayName = "Html";
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ }),

/***/ 61316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ UrlQuery; }
/* harmony export */ });
var UrlQuery = {
    /**
   * Query used on PDP.
   * When this query is assigned, PDP personazation should use multiple segmentation from pet profile
   * */ multiSegmentMode: "msm"
};


/***/ }),

/***/ 12593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useShimmerDataUrl; }
/* harmony export */ });
/* harmony import */ var base_64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97501);
/* harmony import */ var base_64__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(base_64__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


/**
 * Create shimmer effect svg in base64 based string.
 * Expected to be used with `Image` from next.js component
 */ var useShimmerDataUrl = function(param) {
    var width = param.width, height = param.height;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var svgStr = '<svg width="'.concat(width, '" height="').concat(height, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n              <defs>\n                <linearGradient id="g">\n                  <stop stop-color="#eeeeee70" offset="20%" />\n                  <stop stop-color="#eeee" offset="50%" />\n                  <stop stop-color="#eeeeee70" offset="70%" />\n                </linearGradient>\n              </defs>\n              <rect width="').concat(width, '" height="').concat(height, '" fill="#eeeeee70" />\n              <rect id="r" width="').concat(width, '" height="').concat(height, '" fill="url(#g)" />\n              <animate xlink:href="#r" attributeName="x" from="-').concat(width, '" to="').concat(width, '" dur="1s" repeatCount="indefinite"  />\n            </svg>');
        return "data:image/svg+xml;base64,".concat(base_64__WEBPACK_IMPORTED_MODULE_0___default().encode(svgStr));
    }, [
        width,
        height
    ]);
};


/***/ }),

/***/ 57275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var connectors_contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6593);
/* harmony import */ var contexts_pet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75556);
/* harmony import */ var contexts_route__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15250);
/* harmony import */ var modules_content_cms_components_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40009);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86896);
/* harmony import */ var utils_collection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83134);
/* harmony import */ var utils_contentful__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74803);










/**
 * It generates the data used by the Breadcrumbs component on PDPs and CDPs.
 * @param {StaticPDPProduct} product
 */ var useBreadcrumbs = function(param) {
    var product = param.product;
    var ref = (0,modules_content_cms_components_context__WEBPACK_IMPORTED_MODULE_3__/* .useContentful */ .G)(), contentful = ref.data;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var current = (0,contexts_pet__WEBPACK_IMPORTED_MODULE_1__/* .usePetContext */ .w)().current;
    var previousPath = (0,contexts_route__WEBPACK_IMPORTED_MODULE_2__/* .useRouteContext */ .sV)().previousPath;
    var isPreviousPathCollectionPage = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return previousPath === null || previousPath === void 0 ? void 0 : previousPath.includes("collection");
    }, [
        previousPath
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(undefined), previousPathCollectionTitle = ref1[0], setPreviousPathCollectionTitle = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
                var path, response, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                5,
                                6
                            ]);
                            path = isPreviousPathCollectionPage && previousPath ? previousPath.split("/").slice(1, 3).join("/") : null;
                            if (!path) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                (0,connectors_contentful__WEBPACK_IMPORTED_MODULE_0__/* .fetchContentfulByHandle */ .sm)(path)
                            ];
                        case 2:
                            response = _state.sent();
                            setData(response);
                            _state.label = 3;
                        case 3:
                            return [
                                3,
                                6
                            ];
                        case 4:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                6
                            ];
                        case 5:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        isPreviousPathCollectionPage,
        previousPath
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!isLoading) {
            var _breadcrumbsCollectionTitle;
            var newTitle = (_breadcrumbsCollectionTitle = data === null || data === void 0 ? void 0 : data.fields.breadcrumbsCollectionTitle) !== null && _breadcrumbsCollectionTitle !== void 0 ? _breadcrumbsCollectionTitle : data === null || data === void 0 ? void 0 : data.fields.headline;
            if (newTitle !== previousPathCollectionTitle) {
                setPreviousPathCollectionTitle(newTitle);
            }
        }
    }, [
        data,
        isLoading,
        previousPathCollectionTitle
    ]);
    var isCollectionPage = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return (0,utils_collection__WEBPACK_IMPORTED_MODULE_9__/* .isCollectionPage */ .e)(contentful);
    }, [
        contentful
    ]);
    var breadcrumbsCollectionHandle = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if (!isCollectionPage) {
            var ref;
            return isPreviousPathCollectionPage && previousPath ? previousPath.substring(1) : (ref = contentful.fields.mainCollection) === null || ref === void 0 ? void 0 : ref.fields.handle;
        } else {
            return contentful.fields.handle;
        }
    }, [
        contentful,
        isCollectionPage,
        isPreviousPathCollectionPage,
        previousPath, 
    ]);
    var breadcrumbsCollectionTitle = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if (!isCollectionPage) {
            var ref;
            var _breadcrumbsCollectionTitle;
            return isPreviousPathCollectionPage && previousPath ? previousPathCollectionTitle : (_breadcrumbsCollectionTitle = (ref = contentful.fields.mainCollection) === null || ref === void 0 ? void 0 : ref.fields.breadcrumbsCollectionTitle) !== null && _breadcrumbsCollectionTitle !== void 0 ? _breadcrumbsCollectionTitle : // needed as a fallback value for missing breadcrumbs collection titles
            contentful.fields.headline;
        } else if ((0,utils_contentful__WEBPACK_IMPORTED_MODULE_5__/* .isLegacyProductPageModel */ .BV)(contentful)) {
            var _breadcrumbsCollectionTitle1;
            return (_breadcrumbsCollectionTitle1 = contentful.fields.breadcrumbsCollectionTitle) !== null && _breadcrumbsCollectionTitle1 !== void 0 ? _breadcrumbsCollectionTitle1 : // needed as a fallback value for missing breadcrumbs collection titles
            contentful.fields.headline;
        }
    }, [
        contentful,
        isCollectionPage,
        isPreviousPathCollectionPage,
        previousPath,
        previousPathCollectionTitle, 
    ]);
    var breadcrumbList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var _breadcrumbs = [
            {
                element: current === "dogs" ? intl.formatMessage({
                    id: "common:dogs"
                }) : intl.formatMessage({
                    id: "common:cats"
                }),
                href: "/pages/".concat(current === "dogs" ? intl.formatMessage({
                    id: "common:dogs"
                }).toLowerCase() : intl.formatMessage({
                    id: "common:cats"
                }).toLowerCase())
            }, 
        ];
        if (breadcrumbsCollectionHandle && breadcrumbsCollectionTitle) {
            _breadcrumbs.push({
                element: breadcrumbsCollectionTitle,
                href: "/".concat(breadcrumbsCollectionHandle)
            });
        }
        if (product) {
            _breadcrumbs.push({
                element: product.metadata.accentuate.mainTitle || product.title,
                href: "/".concat(contentful.fields.handle)
            });
        }
        return _breadcrumbs;
    }, [
        product,
        current,
        intl,
        breadcrumbsCollectionTitle,
        breadcrumbsCollectionHandle,
        contentful, 
    ]);
    return {
        breadcrumbList: breadcrumbList,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_has_subscription; }
});

// EXTERNAL MODULE: ./src/contexts/auth/index.tsx + 8 modules
var auth = __webpack_require__(62799);
;// CONCATENATED MODULE: ./src/interfaces/customer.ts
var CustomerSubscriptionStatus = {
    /** User has an active subscription */ Active: "Active",
    /** User has stopped subscription */ Churned: "Churned",
    /** User has never had subscription */ None: "None"
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/subscriptions/use-has-subscription.ts



/**
 * Check if user has an at least one active subscription
 */ var useHasSubscription = function() {
    /**
   * @TODO : customer object might not be unreliable due to error and we might have to rely on Ninetailed
   *  https://petsdeli.atlassian.net/browse/PT-4077
   */ var ref = (0,auth/* useAuth */.aC)(), isUserAuthenticated = ref.isUserAuthenticated, customer = ref.customer, fetchCustomer = ref.fetchCustomer;
    /**
   * Refetch customer to get updated status of subscription
   */ (0,react.useEffect)(function() {
        fetchCustomer();
    }, [
        fetchCustomer
    ]);
    return {
        isLoginRequired: !isUserAuthenticated,
        hasSubscription: !!(customer && customer.subscriptionStatus === CustomerSubscriptionStatus.Active)
    };
};
/* harmony default export */ var use_has_subscription = (useHasSubscription);


/***/ }),

/***/ 19617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var hooks_common_use_experiment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30926);

/**
 * Hook to handle the test PT-6874 : Tiny Cart
 * @see https://petsdeli.atlassian.net/browse/PT-6874
 */ var useTestPT6874 = function() {
    var ref = (0,hooks_common_use_experiment__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        baseEntryId: "3wG9UX9NsEcRTMGCxM9uzY"
    }), variant = ref.variant, loading = ref.loading;
    return {
        variant: variant,
        loading: loading,
        showUrgency: variant === 2
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTestPT6874);


/***/ }),

/***/ 81151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var modules_magazine_common_breadcrumb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56710);
/* harmony import */ var modules_magazine_magazine_home_blog_tile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29183);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44012);
/* harmony import */ var _components_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10472);







var Author = function(props) {
    var name = props.name, subtitle = props.subtitle, image = props.image, bio = props.bio, articles = props.articles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "container bg-background-default",
            "data-test": "author-page",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex py-4 text-lg font-medium lg:py-8 lg:text-[16px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_magazine_common_breadcrumb__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        author: props
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative w-full lg:container lg:px-8 ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative w-full lg:rounded-xl lg:bg-other-white",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative h-56 md:block lg:w-2/12 ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        className: "relative z-10 w-full lg:rounded-l-xl ",
                                        "data-test": "author-image",
                                        layout: "fill",
                                        objectFit: "cover"
                                    }, image))
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "lg z-30 -mt-12 w-full md:absolute md:top-0 md:mt-0 md:flex md:h-88 md:items-center lg:z-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative w-full px-4 lg:-inset-y-20 lg:inset-x-12 lg:flex lg:justify-start lg:p-0 lg:px-48",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative z-30 rounded-xl bg-other-white p-4 text-left md:rounded-lg lg:bg-transparent",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "text-3xl font-black text-primary-main lg:col-span-2 lg:mb-0 lg:text-[35px]",
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-xl font-black text-grey-900 lg:text-[20px] lg:text-primary-main",
                                                children: subtitle
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "col-span-2 row-span-2 mb-2 mt-2 text-lg font-extralight text-grey-900 lg:text-[18px] lg:leading-6",
                                                children: bio
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mb-4 pl-4 pt-12 text-2xl font-black leading-tight text-primary-main lg:mb-12 lg:pl-8 lg:text-3xl ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "magazine:author-page:title",
                        values: {
                            name: name
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container grid lg:grid-cols-3",
                        children: articles === null || articles === void 0 ? void 0 : articles.map(function(post) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-6 lg:mr-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_magazine_magazine_home_blog_tile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    article: post.fields,
                                    isMagazineHome: true
                                })
                            }, post.fields.handle);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Author);


/***/ }),

/***/ 44136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ blog_post; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/markdown/index.tsx
var markdown = __webpack_require__(4015);
// EXTERNAL MODULE: ./src/modules/content-cms/util/render-document.tsx + 4 modules
var render_document = __webpack_require__(4967);
// EXTERNAL MODULE: ./src/modules/magazine/common/breadcrumb/index.tsx
var breadcrumb = __webpack_require__(56710);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/magazine/util/index.ts
var util = __webpack_require__(52352);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/image/index.tsx
var components_image = __webpack_require__(10472);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-schemaorg/dist/src/index.js
var src = __webpack_require__(45363);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/blog-post/article-schema-markup.tsx






var ArticleSchemaMarkup = function(param) {
    var author = param.author, body = param.body, subCategory = param.subCategory, mainCategory = param.mainCategory, handle = param.handle, title = param.title, publishDate = param.publishDate;
    var images = body.content.filter(function(v) {
        return v.nodeType === "embedded-entry-block";
    }).map(function(s) {
        return s.data.target.fields;
    }).filter(function(v) {
        return v.image;
    }).map(function(r) {
        return r.image.fields.file.url;
    }).map(function(url) {
        return "https:".concat(url);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", (0,_object_spread/* default */.Z)({}, (0,src/* jsonLdScriptProps */.h6)({
            "@context": "https://schema.org",
            "@type": "Article",
            mainEntityOfPage: {
                "@type": "WebPage",
                "@id": (0,util/* getMagazineUrl */.il)({
                    subCategory: subCategory.fields,
                    mainCategory: mainCategory.fields,
                    blogPost: handle
                }, true)
            },
            headline: "".concat(title),
            image: "".concat(images),
            author: {
                "@type": "Person",
                name: "".concat(author.fields.name),
                url: (0,util/* getMagazineUrl */.il)({
                    author: author.fields
                }, true)
            },
            publisher: {
                "@type": "Organization",
                name: "Pets Deli",
                logo: {
                    "@type": "ImageObject",
                    url: "https://www.petsdeli.de/images/petsdeli-logo.svg"
                }
            },
            datePublished: "".concat(publishDate)
        })))
    });
};
/* harmony default export */ var article_schema_markup = (ArticleSchemaMarkup);

;// CONCATENATED MODULE: ./src/modules/content-cms/sections/blog-post/index.tsx










var BlogPost = function(props) {
    var author = props.author, blogImage = props.blogImage, description = props.description, body = props.body, publishDate = props.publishDate, showTableOfContents = props.showTableOfContents, title = props.title, mainCategory = props.mainCategory, subCategory = props.subCategory, handle = props.handle;
    var tableOfContent = body.content.filter(function(v) {
        return v.nodeType === "heading-2";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(article_schema_markup, {
                author: author,
                body: body,
                mainCategory: mainCategory,
                subCategory: subCategory,
                handle: handle,
                title: title,
                publishDate: publishDate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-test": "blog-post",
                className: "container lg:relative lg:py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col lg:flex-row lg:gap-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "top-0 lg:sticky lg:w-1/3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col text-primary-main ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex pb-2 pt-4 font-medium text-grey lg:pt-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                                            mainCategory: props.mainCategory.fields,
                                            subCategory: props.subCategory.fields,
                                            blogPost: props
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "mb-2 mt-2 text-2xl font-black text-primary-main lg:mb-0 lg:text-3xl",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "-mx-4 my-2 lg:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                                            className: "lg:rounded-xl",
                                            "data-test": "blog-image",
                                            layout: "responsive",
                                            objectFit: "cover",
                                            priority: true
                                        }, blogImage))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                                        children: (0,render_document/* default */.Z)(description)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2 font-black text-primary-main lg:mt-12",
                                        children: (0,util/* formatDate */.p6)(publishDate)
                                    }),
                                    showTableOfContents && tableOfContent.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mr-8 mt-4 flex flex-col border-b border-t border-primary-main pb-2 pt-6 text-sm font-black",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-2",
                                                children: "Inhaltsverzeichnis"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                                style: {
                                                    listStyleType: "decimal"
                                                },
                                                className: "pl-4",
                                                children: tableOfContent.map(function(v) {
                                                    if (v.content[0].nodeType !== "text") {
                                                        return null;
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "cursor-pointer pb-2 underline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#".concat(v.content[0].value),
                                                            children: v.content[0].value
                                                        })
                                                    }, "".concat(v.content[0].value));
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-col text-primary-main lg:w-2/3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden lg:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                                        className: "lg:rounded-xl",
                                        "data-test": "blog-image",
                                        layout: "responsive",
                                        objectFit: "cover"
                                    }, blogImage))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                                        children: (0,render_document/* default */.Z)(body)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,util/* getMagazineUrl */.il)({
                                        author: author.fields
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cursor-pointer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex py-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-24 ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                                                            className: "rounded-lg",
                                                            "data-test": "author-image",
                                                            layout: "responsive"
                                                        }, author.fields.image))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "py-2 pl-2 font-black text-primary-main",
                                                        children: author.fields.name
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var blog_post = (BlogPost);


/***/ }),

/***/ 35268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ content_cms_sections; }
});

// EXTERNAL MODULE: ./src/modules/content-cms/sections/author/index.tsx
var author = __webpack_require__(81151);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/modules/content-cms/util/render-document.tsx + 4 modules
var render_document = __webpack_require__(4967);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/content-container/index.tsx
var content_container = __webpack_require__(20846);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/image/index.tsx
var components_image = __webpack_require__(10472);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/title/index.tsx
var components_title = __webpack_require__(528);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/benefits/benefits.module.css
var benefits_module = __webpack_require__(93000);
var benefits_module_default = /*#__PURE__*/__webpack_require__.n(benefits_module);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/benefits/index.tsx











var sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: true,
    dotsClass: classnames_default()((benefits_module_default()).dot, "pt-4 flex items-center justify-center w-full"),
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: "mx-1 h-3 w-3 rounded-full border border-grey-500 bg-transparent focus:outline-hidden",
            "aria-label": "Slide wechseln"
        });
    },
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 1,
                centerMode: false,
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000
            }
        }, 
    ]
};
var Benefits = function(param) {
    var title = param.title, backgroundColor = param.backgroundColor, benefits = param.benefits;
    var renderImage = function(benefit) {
        if (benefit.fields.imageLink) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: benefit.fields.imageLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, benefit.fields.image), {
                    className: "h-auto w-full rounded-full"
                }))
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, benefit.fields.image), {
                className: "h-auto w-full rounded-full"
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(content_container/* default */.Z, {
        backgroundColor: backgroundColor,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_title/* default */.Z, {
                children: title
            }),
            benefits && benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-mx-6 md:mx-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                    children: benefits.map(function(benefit) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full px-6 md:px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto max-w-3xl items-center md:flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-sm px-10 pb-5 md:mx-0 md:w-1/3 md:max-w-5xl md:px-0 md:pb-0",
                                        children: renderImage(benefit)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center text-center md:w-2/3 md:flex-row md:pl-16 md:text-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-16",
                                                children: benefit.fields.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, benefit.fields.icon), {
                                                    className: "h-auto w-16"
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pt-5 md:pl-6 md:pt-0",
                                                children: (0,render_document/* default */.Z)(benefit.fields.text)
                                            })
                                        ]
                                    })
                                ]
                            }, benefit.sys.id)
                        }, benefit.sys.id);
                    })
                }))
            })
        ]
    });
};
/* harmony default export */ var benefits = (Benefits);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/blog-post/index.tsx + 1 modules
var blog_post = __webpack_require__(44136);
// EXTERNAL MODULE: ./src/components/typography/main-headline/index.tsx
var main_headline = __webpack_require__(36667);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/content-slider/index.tsx






var ContentSlider = function(param) {
    var slides = param.slides, showArrows = param.showArrows, showDots = param.showDots;
    var sliderSettings = {
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: showArrows,
        dots: showDots,
        className: "pd-collection__content-slider slick--circle-arrow max-width"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
        children: slides && slides.map(function(slide) {
            if (!slide || !slide.fields || !slide.fields.backgroundImage) return;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container bg-cover bg-center bg-no-repeat",
                    style: {
                        backgroundImage: "url(".concat(slide.fields.backgroundImage.fields.file.url, ")"),
                        minHeight: "60vh"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-4 leading-tight md:py-6 lg:px-4 lg:py-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg font-black uppercase text-other-white md:text-xl lg:text-2xl",
                                children: slide.fields.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(main_headline/* default */.Z, {
                                color: "text-text-dark-bg-contrast-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "uppercase",
                                    children: slide.fields.subTitle
                                })
                            })
                        ]
                    })
                })
            }, slide.sys.id);
        })
    }));
};
/* harmony default export */ var content_slider = (ContentSlider);

// EXTERNAL MODULE: ./src/tracking/index.ts
var tracking = __webpack_require__(1975);
// EXTERNAL MODULE: ./src/components/button/index.tsx
var components_button = __webpack_require__(9337);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/cta/index.tsx







var Cta = function(param) {
    var backgroundColor = param.backgroundColor, blank = param.blank, customColorBackground = param.customColorBackground, customColorBorder = param.customColorBorder, customColorText = param.customColorText, disableSpacing = param.disableSpacing, id = param.id, link = param.link, style = param.style, text = param.text, textAlignment = param.textAlignment;
    var getButtonStyle = function() {
        var styleAttrs = {};
        if (style === "Custom Color") {
            styleAttrs.color = customColorText;
            styleAttrs.background = customColorBackground;
            if (customColorBorder) {
                styleAttrs = (0,_object_spread/* default */.Z)({}, styleAttrs, {
                    borderColor: customColorBorder,
                    borderWidth: "2px"
                });
            }
        }
        return styleAttrs;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_container/* default */.Z, {
        disableSpacing: disableSpacing,
        backgroundColor: backgroundColor ? backgroundColor : "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("mx-auto flex w-full max-w-4xl", textAlignment && textAlignment === "Left" && "justify-start text-left", textAlignment && textAlignment === "Center" && "justify-center text-center", textAlignment && textAlignment === "Right" && "justify-end text-right"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                href: link,
                target: blank && blank === true ? "_blank" : undefined,
                layout: style === "Orange" ? "orange" : "brand",
                style: getButtonStyle(),
                onClick: function() {
                    text && (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
                        element: [
                            "Contentful",
                            id,
                            text
                        ]
                    }));
                },
                children: text
            })
        })
    });
};
/* harmony default export */ var cta = (Cta);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/customer-io-lead-form/index.tsx
var customer_io_lead_form = __webpack_require__(21132);
// EXTERNAL MODULE: ./src/components/markdown/index.tsx
var markdown = __webpack_require__(4015);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/educational-discount/index.tsx





var EducationalDiscount = function(param) {
    var title = param.title, buttonText = param.buttonText, buttonLink = param.buttonLink, bodyText = param.bodyText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative mx-auto mt-2 px-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto mt-8 flex max-w-lg flex-col rounded-lg border-2 border-primary-main bg-grey-50",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/petsdeli-logo.svg",
                    className: "absolute -top-8 -mb-16 -ml-4 h-16 w-auto",
                    alt: "Pets Deli",
                    role: "presentation"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "m-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "mt-4 text-lg font-black text-primary-main",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                            className: "pb-2 text-primary-main",
                            children: (0,render_document/* default */.Z)(bodyText)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            href: buttonLink,
                            layout: "brand",
                            className: "w-full",
                            children: buttonText
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var educational_discount = (EducationalDiscount);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/faq-section/index.tsx + 1 modules
var faq_section = __webpack_require__(31375);
// EXTERNAL MODULE: ./src/components/impression-tracker/new-impression-tracker.tsx
var new_impression_tracker = __webpack_require__(20286);
// EXTERNAL MODULE: ./src/hooks/common/use-on-screen.ts
var use_on_screen = __webpack_require__(17067);
// EXTERNAL MODULE: ./src/modules/content-cms/components/ribbon-text/index.tsx
var ribbon_text = __webpack_require__(90200);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/tracking/gtm/index.ts + 1 modules
var gtm = __webpack_require__(71295);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/header-with-promo/index.tsx













var HeaderWithPromo = function(param) {
    var disrupterBackgroundColor = param.disrupterBackgroundColor, disrupterText = param.disrupterText, id = param.id, layout = param.layout, promoBackgroundColor = param.promoBackgroundColor, promoButtonLayout = param.promoButtonLayout, promoButtonText = param.promoButtonText, promoHeaderText = param.promoHeaderText, promoHeaderTitle = param.promoHeaderTitle, promoImage = param.promoImage, promoImageMobile = param.promoImageMobile, promoLink = param.promoLink, promoTextColor = param.promoTextColor, promoTitleColor = param.promoTitleColor, richTitle = param.richTitle, showOnlyOnBranch = param.showOnlyOnBranch;
    var $promoHeader = react.useRef(null);
    var onScreen = (0,use_on_screen/* default */.Z)($promoHeader);
    // handles getting value from rich text document node
    var promoTitleValue = react.useMemo(function() {
        return promoHeaderTitle && promoHeaderTitle.content[0].content[0].value;
    }, [
        promoHeaderTitle
    ]);
    // gtm fires for impression if promo header enters the viewport
    react.useEffect(function() {
        var timeout = null;
        if (onScreen === true) {
            timeout = setTimeout(function() {
                (0,tracking/* gtm */.wT)({
                    group: gtm/* Gtm.GroupName.PromoHeader */.P.Df.PromoHeader,
                    name: gtm/* Gtm.CommonEventName.View */.P.IE.View,
                    data: {
                        title: promoTitleValue
                    }
                });
            }, 500);
        }
        return function() {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [
        onScreen,
        promoTitleValue
    ]);
    var getDisrupterColor = function() {
        switch(disrupterBackgroundColor){
            case "Brand-Blue":
                return "#1A335B";
            case "Bermuda-Grau":
                return "#798ca4";
            case "Red-Sale":
                return "#FF5768";
            case "Blue-Neu":
                return "#5500FF";
            case "Limited-Green":
                return "#3ECBAF";
            default:
                return "#F7EB60";
        }
    };
    var trackingId = [
        "Contentful",
        id
    ];
    if (showOnlyOnBranch === "control") return null;
    var renderPromoBanner = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_impression_tracker/* default */.Z, {
            element: trackingId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-test": "promo-banner-section",
                "data-variant": "promo-banner",
                className: "container px-0 py-6 lg:relative lg:py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: promoLink,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: function() {
                            return (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
                                element: trackingId
                            }));
                        },
                        className: "flex flex-col rounded-xl border border-grey-50 shadow-lg lg:h-60",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col lg:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative -mx-4 hidden h-60 lg:mx-0 lg:block lg:w-1/2",
                                    style: {
                                        fontSize: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                                        className: "lg:rounded-l-xl",
                                        "data-test": "promo-header-dt",
                                        layout: "fill",
                                        objectFit: "cover"
                                    }, promoImage))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                                        className: "rounded-t-xl",
                                        "data-test": "promo-header-mb",
                                        layout: "responsive"
                                    }, promoImageMobile))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-between p-4 lg:w-1/2 lg:px-10 lg:py-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-2xl font-black text-primary-main",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                                                        children: (0,render_document/* default */.Z)(promoHeaderTitle)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                                                    children: (0,render_document/* default */.Z)(promoHeaderText)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                            "data-test": "promo-banner-button",
                                            layout: "brand",
                                            className: "mt-4 h-11 w-2/3 rounded-lg! lg:mt-auto lg:h-10 lg:w-80 lg:self-start",
                                            children: promoButtonText
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        });
    };
    if (layout === "Promo Banner") {
        return renderPromoBanner();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_impression_tracker/* default */.Z, {
        element: trackingId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            "data-test": "promo-header-section",
            "data-variant": "new-header",
            className: "container lg:relative lg:py-10",
            ref: $promoHeader,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-mx-4 bg-brand-beige lg:mx-0 lg:h-105 lg:rounded-xl lg:shadow-lg",
                style: {
                    backgroundColor: promoBackgroundColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-4 lg:px-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: promoLink,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "relative flex flex-col lg:flex-row",
                            onClick: function() {
                                (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
                                    element: trackingId
                                }), {
                                    group: gtm/* Gtm.GroupName.PromoHeader */.P.Df.PromoHeader,
                                    name: gtm/* Gtm.CommonEventName.Click */.P.IE.Click,
                                    data: {
                                        title: promoTitleValue
                                    }
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative -mx-4 lg:mx-0 lg:h-105 lg:w-1/2",
                                    style: {
                                        fontSize: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                                        className: " lg:rounded-l-xl",
                                        "data-test": "promo-header-dt",
                                        layout: "fill",
                                        objectFit: "cover"
                                    }, promoImage))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "-mx-4 lg:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                                        "data-test": "promo-header-mb",
                                        layout: "responsive"
                                    }, promoImageMobile))
                                }),
                                disrupterText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        backgroundColor: getDisrupterColor()
                                    },
                                    className: "absolute left-0 top-0 -ml-4 mb-3 inline-block flex h-12 w-24 justify-center rounded-br-lg px-2 pb-1 pt-2 text-3xl font-black text-other-white shadow-sm lg:ml-0 lg:flex lg:rounded-tl-lg",
                                    children: disrupterText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full pb-4 pt-4 lg:flex lg:w-1/2 lg:flex-col lg:justify-center lg:rounded-r-lg lg:p-10 lg:pt-0 lg:pt-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-2 text-2xl font-normal leading-tight text-other-white lg:pb-1 lg:text-3xl",
                                            style: {
                                                color: promoTitleColor
                                            },
                                            children: richTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_text/* default */.Z, {
                                                text: richTitle
                                            }) : promoHeaderTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                                                children: (0,render_document/* default */.Z)(promoHeaderTitle)
                                            }) : null
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "leading-wide pb-4 text-base font-normal text-other-white lg:text-lg",
                                            style: {
                                                color: promoTextColor
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                                                children: (0,render_document/* default */.Z)(promoHeaderText)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                            "data-test": "promo-header-button",
                                            layout: promoButtonLayout !== null && promoButtonLayout !== void 0 ? promoButtonLayout : "brand",
                                            className: "w-full rounded-lg! border-0 text-other-white lg:w-80 lg:border-0",
                                            children: promoButtonText
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var header_with_promo = (HeaderWithPromo);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/ingredients/index.tsx
var ingredients = __webpack_require__(36103);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/ingredients-grid/index.tsx










var IngredientsGrid = function(param) {
    var backgroundColor = param.backgroundColor, title = param.title, slider = param.slider, ingredients = param.ingredients, richTitle = param.richTitle;
    var renderImage = function(ingredient) {
        if (ingredient.fields.imageLink) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto w-full rounded-full",
                style: {
                    maxWidth: "200px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: ingredient.fields.imageLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ingredient.fields.image), {
                        className: "rounded-full"
                    }))
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto w-full rounded-full",
                style: {
                    maxWidth: "200px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ingredient.fields.image), {
                    className: "rounded-full"
                }))
            });
        }
    };
    var renderIngredient = function(ingredient) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                renderImage(ingredient),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        ingredient.fields.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm font-black uppercase leading-loose text-primary-main",
                            children: ingredient.fields.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-2",
                            children: ingredient.fields.text
                        }),
                        ingredient.fields.ctaText && ingredient.fields.imageLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            href: ingredient.fields.imageLink,
                            className: "mt-2",
                            layout: "brand",
                            children: ingredient.fields.ctaText
                        })
                    ]
                })
            ]
        });
    };
    var sliderSettings = {
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        className: "pd-ingredient-slider slick--circle-arrow max-width",
        responsive: [
            {
                breakpoint: 798,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(content_container/* default */.Z, {
        backgroundColor: backgroundColor,
        children: [
            richTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_text/* default */.Z, {
                text: richTitle
            }) : title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_title/* default */.Z, {
                children: title
            }) : null,
            slider && slider === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                children: ingredients && ingredients.map(function(ingredient) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full px-3 text-center",
                            children: renderIngredient(ingredient)
                        })
                    }, ingredient.sys.id);
                })
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-mx-3 flex flex-wrap items-start justify-center",
                children: ingredients && ingredients.map(function(ingredient) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full px-3 text-center md:w-1/2 lg:w-1/3",
                        children: renderIngredient(ingredient)
                    }, ingredient.sys.id);
                })
            })
        ]
    });
};
/* harmony default export */ var ingredients_grid = (IngredientsGrid);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/product-slider/index.tsx
var product_slider = __webpack_require__(61447);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/promo-bar/index.tsx + 4 modules
var promo_bar = __webpack_require__(21368);
// EXTERNAL MODULE: ./src/modules/content-cms/components/context.tsx
var context = __webpack_require__(40009);
// EXTERNAL MODULE: ./src/modules/product-details/components/product-details-header/index.tsx + 25 modules
var product_details_header = __webpack_require__(80088);
// EXTERNAL MODULE: ./src/modules/product-details/components/product-details-header/state.tsx
var state = __webpack_require__(724);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/single-product-panel/index.tsx






var SingleProductPanel = function(param) {
    var productHandle = param.productHandle, backgroundColor = param.backgroundColor;
    var shopifyProductDetailMap = (0,context/* useContentful */.G)().shopifyProductDetailMap;
    if (!shopifyProductDetailMap[productHandle]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(state/* ProductDetailsHeaderProvider */.OJ, {
        productDetails: shopifyProductDetailMap[productHandle],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(content_container/* default */.Z, {
            backgroundColor: backgroundColor ? backgroundColor : "white",
            className: "container rounded-lg border border-grey-300",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_details_header/* default */.Z, {
                displayAsSection: true
            })
        })
    });
};
/* harmony default export */ var single_product_panel = (SingleProductPanel);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/slider/index.tsx + 3 modules
var slider = __webpack_require__(2552);
// EXTERNAL MODULE: ./src/hooks/common/use-is-client.tsx
var use_is_client = __webpack_require__(7231);
// EXTERNAL MODULE: ./node_modules/react-calendly/dist/index.es.js
var index_es = __webpack_require__(20761);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/subscription/index.tsx














var Subscription = function(param) {
    var title = param.title, backgroundColor = param.backgroundColor, text = param.text, image = param.image, imageLink = param.imageLink, buttonLink = param.buttonLink, buttonText = param.buttonText, richTitle = param.richTitle;
    var renderImage = function() {
        if (imageLink) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: imageLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                    className: "max-w-auto h-auto rounded-full"
                }))
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                className: "h-auto max-w-full rounded-full"
            }));
        }
    };
    var isClient = (0,use_is_client/* default */.Z)().isClient;
    var rootElement = null;
    if (typeof document !== "undefined") {
        rootElement = document.getElementById("__next");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(content_container/* default */.Z, {
        backgroundColor: backgroundColor,
        children: [
            richTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_text/* default */.Z, {
                text: richTitle
            }) : title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_title/* default */.Z, {
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "items-center md:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center md:w-1/2 md:pr-10",
                        children: renderImage()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-10 md:w-1/2 md:pt-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                            children: text && (0,render_document/* default */.Z)(text)
                        })
                    })
                ]
            }),
            buttonLink && buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center pt-4 text-center",
                children: buttonText === "TERMIN VEREINBAREN" && rootElement && isClient ? // Calendly termin pop-up for Beratung Page
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* PopupButton */.cy, {
                            rootElement: rootElement,
                            className: "text-md font-black uppercase tracking-wide",
                            text: buttonText,
                            url: "https://calendly.com/futterberatungpetsdeli/telefonische-futterberatung-von-pets-deli" || 0
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: buttonLink,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        children: buttonText
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var subscription = (Subscription);

;// CONCATENATED MODULE: ./src/modules/content-cms/sections/text/index.tsx








var Text = function(param) {
    var title = param.title, text = param.text, textAlignment = param.textAlignment, backgroundColor = param.backgroundColor, disableSpacing = param.disableSpacing, hideTitle = param.hideTitle, richTitle = param.richTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_container/* default */.Z, {
        disableSpacing: disableSpacing,
        backgroundColor: backgroundColor,
        children: text && /*#__PURE__*/ (0,jsx_runtime.jsxs)(markdown/* default */.Z, {
            className: classnames_default()("mx-auto w-full leading-normal lg:leading-relaxed", textAlignment && textAlignment === "Left" && "text-left", textAlignment && textAlignment === "Center" && "text-center", textAlignment && textAlignment === "Right" && "text-right"),
            children: [
                richTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_text/* default */.Z, {
                    text: richTitle
                }) : title && hideTitle !== true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_title/* default */.Z, {
                    children: title
                }) : null,
                (0,render_document/* default */.Z)(text)
            ]
        })
    });
};
/* harmony default export */ var sections_text = (Text);

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/text-image-combo/index.tsx













var TextImageCombo = function(param) {
    var title = param.title, subTitle = param.subTitle, hideTitle = param.hideTitle, disableSpacing = param.disableSpacing, mirrorColumns = param.mirrorColumns, backgroundColor = param.backgroundColor, image = param.image, testImage = param.testImage, imageMobile = param.imageMobile, testImageMobile = param.testImageMobile, imageLink = param.imageLink, imageMaximumWidth = param.imageMaximumWidth, imagePlacement = param.imagePlacement, text = param.text, framelessImage = param.framelessImage, richTitle = param.richTitle;
    var renderImage = function() {
        var imageProps = {
            style: {}
        };
        if (!image) return "";
        if (imageMaximumWidth) {
            imageProps.style.maxWidth = "".concat(imageMaximumWidth, "px");
            imageProps.style.width = "100%";
        }
        if (framelessImage) {
            imageProps.style.marginBottom = "-9px";
        }
        var _image = testImage || image;
        var _imageMobile = testImageMobile || imageMobile;
        if (imageLink) {
            var child = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(imageMobile && "hidden lg:block"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({}, _image))
                    }),
                    _imageMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({}, _imageMobile))
                    })
                ]
            });
            if ((0,url/* isAbsoluteUrl */.s)(imageLink)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: imageLink,
                        children: child
                    })
                }));
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: imageLink,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: child
                        })
                    })
                }));
            }
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(_imageMobile && "hidden lg:block"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({}, _image))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden",
                        children: _imageMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({}, _imageMobile))
                        })
                    })
                ]
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(content_container/* default */.Z, {
        disableSpacing: disableSpacing,
        backgroundColor: backgroundColor ? backgroundColor : "white",
        children: [
            richTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_text/* default */.Z, {
                text: richTitle
            }) : title && hideTitle !== true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center text-sm font-black uppercase leading-loose ",
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_title/* default */.Z, {
                        children: title
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex flex-col items-center", mirrorColumns && mirrorColumns === true ? "md:flex-row-reverse" : "md:flex-row"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(!text ? "flex w-full" : "flex w-full items-center pb-6 pr-2 md:w-1/2 md:pb-0", imagePlacement && imagePlacement === "left" && "justify-start text-left", imagePlacement && imagePlacement === "center" && "justify-center text-center", imagePlacement && imagePlacement === "right" && "justify-end text-right"),
                        children: renderImage()
                    }),
                    text && /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                        className: "w-full md:w-1/2",
                        children: (0,render_document/* default */.Z)(text)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var text_image_combo = (TextImageCombo);

// EXTERNAL MODULE: ./node_modules/@typeform/embed/lib/api.js
var api = __webpack_require__(94880);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/typeform/index.tsx








/** Component to display Typeform app for Contentful  */ var Typeform = function(param) {
    var title = param.title, url = param.url, buttonText = param.buttonText, buttonSize = param.buttonSize, customBackgroundColor = param.customBackgroundColor, disableSpacing = param.disableSpacing, backgroundColor = param.backgroundColor, richTitle = param.richTitle;
    var typeformRef = react.useRef({
        open: function() {
            return true;
        }
    });
    react.useEffect(function() {
        typeformRef.current = api.makePopup(url, {
            mode: "popup",
            autoClose: 3000,
            autoOpen: false,
            hideHeaders: true,
            hideFooters: true,
            onSubmit: function onSubmit() {
                (0,gtm/* gtm */.w)({
                    group: gtm/* Gtm.GroupName.Form */.P.Df.Form,
                    name: gtm/* Gtm.CommonEventName.Submit */.P.IE.Submit,
                    data: {
                        label: title
                    }
                });
            }
        });
    }, [
        url,
        title
    ]);
    var buttonStyle = {};
    if (customBackgroundColor) {
        buttonStyle.backgroundColor = "".concat(customBackgroundColor);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(content_container/* default */.Z, {
        disableSpacing: disableSpacing,
        backgroundColor: backgroundColor ? backgroundColor : "#fff",
        children: [
            richTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_text/* default */.Z, {
                text: richTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex w-full justify-center text-center", !disableSpacing && "-mt-8 md:-mt-10"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        type: "text/css",
                        dangerouslySetInnerHTML: {
                            __html: "\n          div[data-section-id=header] {\n            z-index: 10000 !important;\n          }\n        "
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        layout: "brand",
                        size: buttonSize,
                        onClick: function() {
                            typeformRef.current.open();
                        },
                        style: buttonStyle,
                        children: buttonText ? buttonText : "Starten"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var typeform = (Typeform);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/video/index.tsx + 1 modules
var video = __webpack_require__(8918);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/index.ts




















var sections = {
    SectionBenefits: benefits,
    SectionIngredients: ingredients/* default */.Z,
    SectionSubscription: subscription,
    SectionContentSlider: content_slider,
    SectionCta: cta,
    SectionTypeform: typeform,
    SectionIngredientsGrid: ingredients_grid,
    SectionText: sections_text,
    SectionTextimageCombo: text_image_combo,
    Sectionslider: slider/* default */.Z,
    SectionVideo: video/* default */.Z,
    HeaderWithPromo: header_with_promo,
    SectionCustomerIoLeadForm: customer_io_lead_form/* default */.Z,
    SectionEducationalDiscount: educational_discount,
    SectionFaQs: faq_section/* default */.Z,
    SectionProductSlider: product_slider/* default */.Z,
    SingleProductPanel: single_product_panel,
    BlogPost: blog_post/* default */.Z,
    PromoBar: promo_bar/* default */.Z,
    Author: author/* default */.Z
};
/* harmony default export */ var content_cms_sections = (sections);


/***/ }),

/***/ 41393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_price__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47969);
/* harmony import */ var constants_order__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7209);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





var PriceElement = function(param) {
    var className = param.className, couponPrices = param.couponPrices, orderType = param.orderType, pricePerKilo = param.pricePerKilo, product = param.product, selectedVariantDiscount = param.selectedVariantDiscount, _size = param.size, size = _size === void 0 ? "large" : _size;
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!couponPrices) {
        return null;
    }
    var couponName = (ref = couponPrices.coupon) === null || ref === void 0 ? void 0 : ref.code;
    var discountPercentage = (ref1 = couponPrices.coupon) === null || ref1 === void 0 ? void 0 : ref1.percentage;
    var compareAtPrice = Number(orderType === constants_order__WEBPACK_IMPORTED_MODULE_3__/* .OrderType.ONE_OFF */ .mr.ONE_OFF ? ((ref2 = selectedVariantDiscount.one_off.compare) === null || ref2 === void 0 ? void 0 : ref2.before) || selectedVariantDiscount.one_off.price : (ref3 = selectedVariantDiscount.subscription) === null || ref3 === void 0 ? void 0 : ref3.compare.before);
    var discountedPrice = Number(orderType === constants_order__WEBPACK_IMPORTED_MODULE_3__/* .OrderType.ONE_OFF */ .mr.ONE_OFF ? ((ref4 = selectedVariantDiscount.one_off.compare) === null || ref4 === void 0 ? void 0 : ref4.after) || selectedVariantDiscount.one_off.price : (ref5 = selectedVariantDiscount.subscription) === null || ref5 === void 0 ? void 0 : ref5.compare.after);
    var hasCouponDiscount = discountPercentage && couponName && discountedPrice;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("h-14 ", !hasCouponDiscount && "mt-2", className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-end justify-end md:text-3xl",
                children: [
                    hasCouponDiscount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-sm leading-[14px] text-text-secondary line-through",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    value: Number(compareAtPrice)
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("font-black text-text-light-bg-discounted-price", size === "small" && "text-lg", size === "large" && "text-2xl"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    value: Number(discountedPrice)
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            compareAtPrice > discountedPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-sm leading-[14px] text-text-secondary line-through",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    value: Number(compareAtPrice)
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("font-black leading-[30px]", size === "small" && "text-lg", size === "large" && "text-2xl", compareAtPrice > discountedPrice && "text-text-light-bg-discounted-price"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    value: Number(discountedPrice)
                                })
                            })
                        ]
                    }),
                    product && !product.tags.includes("KGP") && pricePerKilo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "text-sm leading-3 text-text-secondary",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                value: pricePerKilo
                            }),
                            "/kg"
                        ]
                    }) : null
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceElement);


/***/ }),

/***/ 80088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_details_header; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/product.ts
var api_product = __webpack_require__(94070);
// EXTERNAL MODULE: ./src/assets/icons/animated-spinner.svg
var animated_spinner = __webpack_require__(48110);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/badge/index.tsx
var badge = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(9899);
// EXTERNAL MODULE: ./src/contexts/segmentation.tsx + 3 modules
var contexts_segmentation = __webpack_require__(42067);
// EXTERNAL MODULE: ./src/hooks/common/use-experiment.ts + 1 modules
var use_experiment = __webpack_require__(30926);
// EXTERNAL MODULE: ./src/hooks/common/use-mobile.tsx
var use_mobile = __webpack_require__(44621);
// EXTERNAL MODULE: ./src/hooks/product/use-breadcrumbs.tsx
var use_breadcrumbs = __webpack_require__(57275);
// EXTERNAL MODULE: ./src/modules/content-cms/components/context.tsx
var context = __webpack_require__(40009);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/icons/add.svg
var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgAdd(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#add_svg__clip0_434_2182)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.894.477a.504.504 0 00-.352.287c-.045.097-.041-.21-.041 3.438V7.5H4.2c-3.648 0-3.34-.004-3.437.041a.514.514 0 00-.262.27.53.53 0 000 .375.524.524 0 00.353.304c.041.01.258.01 3.345.013l3.3.002V11.8c0 3.645-.003 3.337.042 3.435a.515.515 0 00.313.277.39.39 0 00.145.016c.08 0 .1-.002.145-.016a.522.522 0 00.346-.369c.01-.04.01-.258.013-3.34l.002-3.298 3.297-.002c3.083-.002 3.3-.003 3.341-.013a.522.522 0 00.369-.346.39.39 0 00.016-.145.39.39 0 00-.016-.145.514.514 0 00-.277-.313c-.098-.045.21-.041-3.435-.041H8.506L8.504 4.2C8.502 1.113 8.5.896 8.49.855a.52.52 0 00-.346-.367.61.61 0 00-.25-.01z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "add_svg__clip0_434_2182"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
/* harmony default export */ var add = (SvgAdd);
;// CONCATENATED MODULE: ./src/assets/icons/subtract.svg
var _path;
function subtract_extends() { return subtract_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, subtract_extends.apply(null, arguments); }

function SvgSubtract(props) {
  return /*#__PURE__*/react.createElement("svg", subtract_extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.911 7.527a.502.502 0 00-.438.422.504.504 0 00.407.567c.043.008 1.14.009 7.146.007 6.744-.001 7.096-.002 7.132-.013.17-.05.31-.186.355-.35a.504.504 0 00-.356-.623l-.05-.014H8.035c-3.89 0-7.095.001-7.124.004z",
    fill: "currentColor"
  })));
}
/* harmony default export */ var subtract = (SvgSubtract);
// EXTERNAL MODULE: ./node_modules/lodash/clamp.js
var clamp = __webpack_require__(74691);
var clamp_default = /*#__PURE__*/__webpack_require__.n(clamp);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/amount-input-new/input.tsx







var DEBOUNCE_DELAY = 500;
var AmountInput = function(param) {
    var className = param.className, debounced = param.debounced, _maxValue = param.maxValue, maxValue = _maxValue === void 0 ? Infinity : _maxValue, _minValue = param.minValue, minValue = _minValue === void 0 ? 0 : _minValue, suborderPage = param.suborderPage, value = param.value, onChange = param.onChange;
    var ref = (0,react.useState)(value || minValue), internalValue = ref[0], setIntervalValue = ref[1];
    var onChangeRef = (0,react.useRef)(onChange);
    (0,react.useEffect)(function() {
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    (0,react.useEffect)(function() {
        if (value && value !== internalValue) {
            setIntervalValue(value);
        }
    }, [
        value
    ]); // `internalValue` shouldn't be in deps
    var onChangeDebounced = (0,react.useMemo)(function() {
        if (!debounced) {
            return function(value) {
                return onChangeRef.current(value);
            };
        }
        return debounce_default()(function(value) {
            return onChangeRef.current(value);
        }, DEBOUNCE_DELAY);
    }, [
        debounced
    ]);
    var onIncrement = (0,react.useCallback)(function(event) {
        event.preventDefault();
        var newValue = clamp_default()(internalValue + 1, minValue, maxValue);
        setIntervalValue(newValue);
        onChangeDebounced(newValue);
    }, [
        internalValue,
        minValue,
        maxValue,
        onChangeDebounced
    ]);
    var onDecrement = (0,react.useCallback)(function(event) {
        event.preventDefault();
        var newValue = clamp_default()(internalValue - 1, minValue, maxValue);
        setIntervalValue(newValue);
        onChangeDebounced(newValue);
    }, [
        internalValue,
        minValue,
        maxValue,
        onChangeDebounced
    ]);
    var onInputChange = (0,react.useCallback)(function(event) {
        event.stopPropagation();
        var newValue = clamp_default()(parseInt(event.target.value, 10), minValue, maxValue) || minValue;
        setIntervalValue(newValue);
        if (newValue !== 0) {
            onChangeDebounced(newValue);
        }
    }, [
        minValue,
        maxValue,
        setIntervalValue,
        onChangeDebounced
    ]);
    var onInputBlur = (0,react.useCallback)(function(event) {
        var newValue = clamp_default()(parseInt(event.target.value, 10), minValue, maxValue) || minValue;
        setIntervalValue(newValue);
        onChangeRef.current(newValue);
    }, [
        minValue,
        maxValue,
        setIntervalValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex h-[42px] items-center justify-between rounded-lg border border-grey-200 px-3", className),
        "data-test": "amount-section-mobile ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "flex h-8 w-8 items-center justify-center",
                "data-test": "amount-button-minus",
                disabled: suborderPage,
                onClick: onDecrement,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(subtract, {
                    className: "h-4 w-4 grow-0 text-text-secondary"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                "data-test": "amount-input",
                onBlur: onInputBlur,
                onChange: onInputChange,
                value: internalValue,
                className: "w-12 text-center outline-hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "flex h-8 w-8 items-center justify-center",
                "data-test": "amount-button-plus",
                disabled: suborderPage,
                onClick: onIncrement,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add, {
                    className: "h-4 w-4 grow-0 text-text-secondary"
                })
            })
        ]
    });
};
/* harmony default export */ var input = (AmountInput);

// EXTERNAL MODULE: ./src/components/shipping-element/index.tsx + 3 modules
var shipping_element = __webpack_require__(74393);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./src/constants/feature-flag.ts
var feature_flag = __webpack_require__(93841);
// EXTERNAL MODULE: ./src/constants/order.ts
var order = __webpack_require__(7209);
// EXTERNAL MODULE: ./src/contexts/auth/index.tsx + 8 modules
var auth = __webpack_require__(62799);
// EXTERNAL MODULE: ./src/contexts/common.tsx + 5 modules
var common = __webpack_require__(21310);
// EXTERNAL MODULE: ./src/hooks/common/use-is-existing-customer.tsx + 1 modules
var use_is_existing_customer = __webpack_require__(69133);
// EXTERNAL MODULE: ./src/hooks/subscriptions/use-has-subscription.ts + 1 modules
var use_has_subscription = __webpack_require__(602);
// EXTERNAL MODULE: ./src/modules/cart/components/tiny-cart/hooks/use-test-pt6874/index.tsx
var use_test_pt6874 = __webpack_require__(19617);
// EXTERNAL MODULE: ./src/modules/product-details/components/product-details-header/state.tsx
var state = __webpack_require__(724);
// EXTERNAL MODULE: ./src/contexts/cart.tsx + 4 modules
var cart = __webpack_require__(15731);
// EXTERNAL MODULE: ./src/contexts/tracking.tsx + 1 modules
var tracking = __webpack_require__(70315);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/tracking/gtm/index.ts + 1 modules
var gtm = __webpack_require__(71295);
;// CONCATENATED MODULE: ./src/modules/product-details/hooks/useProductDetailsCart.ts










var useProductDetailsCart = function() {
    var ref = (0,state/* useProductDetailsHeaderState */.Xe)(), crossSellProductDetails = ref.crossSellProductDetails, crossSellProductQuantity = ref.crossSellProductQuantity, orderType = ref.orderType, price = ref.price, product = ref.product, selectedVariant = ref.selectedVariant, selectedVariantId = ref.selectedVariantId, subscriptionInterval = ref.subscriptionInterval, variantQuantity = ref.variantQuantity, setCrossSellProductQuantity = ref.setCrossSellProductQuantity;
    var ref1 = (0,cart/* useCart */.j)(), addProductsToCart = ref1.addProductsToCart, addSubItemToCart = ref1.addSubItemToCart;
    var getProductList = (0,tracking/* useTrackingContext */.E)().getProductList;
    var query = (0,next_router.useRouter)().query;
    var getListData = (0,react.useCallback)(function(productId) {
        if (query.list && query.list.includes("account_promo")) {
            return "Account Promo";
        }
        if (query.list && query.list.includes("search")) {
            return "search";
        }
        return getProductList(productId, "");
    }, [
        getProductList,
        query.list
    ]);
    var onAddToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var promises, _tmp, _tmp1, _tmp2, _tmp3, _tmp4, _tmp5, _tmp6;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!selectedVariantId) {
                        return [
                            2,
                            null
                        ];
                    }
                    promises = [];
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    _tmp3 = {};
                    if (orderType === order/* OrderType.SUBSCRIPTION */.mr.SUBSCRIPTION && subscriptionInterval) {
                        promises.push(addSubItemToCart((_tmp.variantId = selectedVariantId + "", _tmp.quantity = variantQuantity, _tmp.interval = subscriptionInterval, _tmp)));
                        if (crossSellProductDetails && !!crossSellProductQuantity) {
                            promises.push(addProductsToCart([
                                (_tmp1.variantId = crossSellProductDetails.variantId + "", _tmp1.quantity = crossSellProductQuantity, _tmp1)
                            ]).then(function() {
                                setCrossSellProductQuantity(0);
                            }));
                        }
                    } else {
                        promises.push(addProductsToCart([
                            (_tmp2.variantId = selectedVariantId + "", _tmp2.quantity = variantQuantity, _tmp2)
                        ].concat((0,_to_consumable_array/* default */.Z)(crossSellProductDetails ? [
                            (_tmp3.variantId = crossSellProductDetails.variantId + "", _tmp3.quantity = crossSellProductQuantity, _tmp3)
                        ] : []))).then(function() {
                            setCrossSellProductQuantity(0);
                        }));
                    }
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    _state.sent();
                    _tmp4 = {};
                    (0,gtm/* gtm */.w)((_tmp4.group = gtm/* Gtm.GroupName.Product */.P.Df.Product, _tmp4.name = gtm/* Gtm.ProductEventName.AddToCart */.P.MB.AddToCart, _tmp4.data = {
                        list: getListData(product.id),
                        item: {
                            productId: product.id + "",
                            variantTitle: selectedVariant.title,
                            variantId: selectedVariantId + "",
                            productTitle: product.title,
                            productType: product.productType,
                            tags: product.tags.join(","),
                            sku: selectedVariant.sku,
                            quantity: variantQuantity,
                            interval: orderType === order/* OrderType.SUBSCRIPTION */.mr.SUBSCRIPTION ? subscriptionInterval : undefined,
                            price: Math.round(price * 100)
                        }
                    }, _tmp4));
                    _tmp5 = {};
                    crossSellProductDetails && crossSellProductQuantity > 0 && (0,gtm/* gtm */.w)((_tmp5.group = gtm/* Gtm.GroupName.Product */.P.Df.Product, _tmp5.name = gtm/* Gtm.ProductEventName.AddToCart */.P.MB.AddToCart, _tmp5.data = {
                        list: getProductList(crossSellProductDetails.productId, "PDP Cross Sell"),
                        item: {
                            productId: product.id + "",
                            variantTitle: selectedVariant.title,
                            variantId: selectedVariantId + "",
                            productTitle: product.title,
                            productType: product.productType,
                            tags: product.tags.join(","),
                            sku: selectedVariant.sku,
                            quantity: variantQuantity,
                            interval: orderType === order/* OrderType.SUBSCRIPTION */.mr.SUBSCRIPTION ? subscriptionInterval : undefined,
                            price: Math.round(price * 100)
                        }
                    }, _tmp5));
                    _tmp6 = {};
                    crossSellProductDetails && crossSellProductQuantity > 0 && (0,gtm/* gtm */.w)((_tmp6.group = gtm/* Gtm.GroupName.Product */.P.Df.Product, _tmp6.name = gtm/* Gtm.ProductEventName.AddToCart */.P.MB.AddToCart, _tmp6.data = {
                        list: getProductList(crossSellProductDetails.productId, "PDP Cross Sell"),
                        item: {
                            productId: crossSellProductDetails.productId + "",
                            variantTitle: crossSellProductDetails.variantTitle,
                            variantId: crossSellProductDetails.variantId + "",
                            productTitle: crossSellProductDetails.productTitle,
                            productType: crossSellProductDetails.productType,
                            tags: crossSellProductDetails.tags,
                            sku: crossSellProductDetails.sku,
                            quantity: crossSellProductQuantity,
                            price: crossSellProductDetails.price
                        }
                    }, _tmp6));
                    return [
                        2
                    ];
            }
        });
    }), [
        addProductsToCart,
        addSubItemToCart,
        crossSellProductDetails,
        crossSellProductQuantity,
        getListData,
        getProductList,
        orderType,
        price,
        product.id,
        product.productType,
        product.tags,
        product.title,
        selectedVariant,
        selectedVariantId,
        setCrossSellProductQuantity,
        subscriptionInterval,
        variantQuantity, 
    ]);
    return {
        onAddToCart: onAddToCart
    };
};
/* harmony default export */ var hooks_useProductDetailsCart = (useProductDetailsCart);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.mjs
var middleware = __webpack_require__(782);
;// CONCATENATED MODULE: ./src/stores/product-details.ts



/**
 * Zustand Store to manage the current order type in the product details page
 */ var useProductDetailsStore = (0,esm/* create */.Ue)((0,middleware/* persist */.tJ)(function(set) {
    return {
        currentOrderType: order/* OrderType.ONE_OFF */.mr.ONE_OFF,
        hasUserChangedOrderType: false,
        setCurrentOrderType: function(orderType) {
            return set({
                currentOrderType: orderType
            });
        },
        setHasUserChangedOrderType: function(value) {
            return set({
                hasUserChangedOrderType: value
            });
        }
    };
}, {
    name: "pd:default-order-type"
}));

// EXTERNAL MODULE: ./src/utils/product.ts
var utils_product = __webpack_require__(92284);
;// CONCATENATED MODULE: ./src/assets/icons/bell-notification.svg
var bell_notification_path;
function bell_notification_extends() { return bell_notification_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, bell_notification_extends.apply(null, arguments); }

function SvgBellNotification(props) {
  return /*#__PURE__*/react.createElement("svg", bell_notification_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bell_notification_path || (bell_notification_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.726.769a8.085 8.085 0 00-7.75 7.08c-.057.458-.053.16-.059 4.194l-.006 3.706-.022.096c-.063.278-.17.471-.37.672-.255.254-.445.35-.701.35-.355.002-.66.129-.91.379-.28.279-.404.622-.371 1.022.025.315.148.575.38.803.197.195.434.314.704.355.138.021 18.62.021 18.758 0 .27-.04.507-.16.704-.355.231-.228.355-.489.38-.803a1.25 1.25 0 00-.264-.903 1.27 1.27 0 00-1.017-.498c-.257 0-.445-.095-.7-.35a1.268 1.268 0 01-.371-.672l-.022-.096-.006-3.706c-.006-4.035-.002-3.736-.058-4.195a8.093 8.093 0 00-5.409-6.65 7.961 7.961 0 00-2.251-.425 7.91 7.91 0 00-.639-.004zm-.13 2.582a5.555 5.555 0 00-2.548.843A5.606 5.606 0 007.512 5.65a5.555 5.555 0 00-.98 2.499c-.043.34-.042.258-.042 3.966 0 2.187-.004 3.574-.01 3.682-.012.218-.031.374-.068.557a4.143 4.143 0 01-.134.505c0 .005 2.575.008 5.722.008 3.147 0 5.722-.003 5.722-.008a4.232 4.232 0 01-.177-.765 4.998 4.998 0 01-.025-.288 329.34 329.34 0 01-.01-3.686c0-3.717 0-3.63-.043-3.974a5.594 5.594 0 00-.67-2.012 5.53 5.53 0 00-4.413-2.783 9 9 0 00-.787 0zM10.364 20.67a1.205 1.205 0 00-.722.299 1.27 1.27 0 00-.439.757c-.019.116-.019.334 0 .448.037.229.133.43.296.62.147.17.352.31.548.375.231.076.23.076 2.06.072 1.726-.004 1.624 0 1.83-.067.184-.058.348-.16.497-.31a1.224 1.224 0 00.38-.912 1.2 1.2 0 00-.219-.725 1.31 1.31 0 00-.672-.503c-.194-.061-.099-.058-1.86-.06-.881 0-1.646.002-1.699.006z",
    fill: "currentColor"
  })));
}
/* harmony default export */ var bell_notification = (SvgBellNotification);
// EXTERNAL MODULE: ./src/components/button-new/index.tsx
var button_new = __webpack_require__(76712);
// EXTERNAL MODULE: ./src/components/impression-tracker/new-impression-tracker.tsx
var new_impression_tracker = __webpack_require__(20286);
// EXTERNAL MODULE: ./src/tracking/index.ts
var src_tracking = __webpack_require__(1975);
;// CONCATENATED MODULE: ./src/modules/product-details/components/buy-panel/components/buy-button/index.tsx









var TRACKING_NAME = "PDP Add-to-Cart";
var BuyButton = function(param) {
    var className = param.className, isCartAnimationOn = param.isCartAnimationOn, product = param.product, selectedVariant = param.selectedVariant, onAddToCart = param.onAddToCart, onBackInStockClick = param.onBackInStockClick;
    // Array of product IDs to be set directly as out of stock as requested by the shop management team, as they will never be in stock but are used for bundles.
    var soldOutProducts = [
        6969936445474
    ];
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var addToCart = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            onAddToCart(event)
                        ];
                    case 1:
                        _state.sent();
                        _tmp = {};
                        (0,src_tracking/* gtm */.wT)((0,src_tracking/* selectElement */.G7)((_tmp.element = TRACKING_NAME, _tmp)));
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onAddToCart
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_impression_tracker/* default */.Z, {
        element: TRACKING_NAME,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: selectedVariant && selectedVariant.availableForSale ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_new/* default */.Z, {
                "data-test": "add-to-cart-cta",
                disabled: loading || isCartAnimationOn,
                layout: "contained",
                actionDone: isCartAnimationOn,
                size: "large",
                loading: loading,
                onClick: addToCart,
                iconLeft: isCartAnimationOn,
                children: isCartAnimationOn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "pdp:buy-panel:added-to-cart"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: product && product.tags.includes("Preorder") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "pdp:buy-panel:preorder"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "pdp:buy-panel:add-to-cart"
                    })
                })
            }) : soldOutProducts.includes(product.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_new/* default */.Z, {
                "data-test": "back-in-stock-cta",
                layout: "contained",
                size: "large",
                disabled: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "pdp:buy-panel:product-out-stock"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_new/* default */.Z, {
                "data-test": "back-in-stock-cta",
                layout: "contained",
                size: "large",
                onClick: function(event) {
                    event.preventDefault();
                    onBackInStockClick(event);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "pdp:buy-panel:back-in-stock"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bell_notification, {
                        className: "h-4 w-4"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var buy_button = (BuyButton);

// EXTERNAL MODULE: ./src/modules/product-details/components/buy-panel/components/order-type-form/index.tsx
var order_type_form = __webpack_require__(74434);
// EXTERNAL MODULE: ./src/modules/product-details/components/buy-panel/components/price-element/index.tsx
var price_element = __webpack_require__(41393);
// EXTERNAL MODULE: ./src/modules/product-details/components/buy-panel/components/subscription-interval-form/index.tsx
var subscription_interval_form = __webpack_require__(61403);
// EXTERNAL MODULE: ./src/assets/icons/expand-more.svg
var expand_more = __webpack_require__(60218);
;// CONCATENATED MODULE: ./src/modules/product-details/components/buy-panel/components/variant-selector/index.tsx





var VariantSelector = function(param) {
    var product = param.product, selectedVariantId = param.selectedVariantId, onVariantIdChange = param.onVariantIdChange;
    var variants = product.variants;
    var onVariantChange = (0,react.useCallback)(function(event) {
        var variantId = parseInt(event.target.value, 10);
        if (selectedVariantId === variantId) return;
        onVariantIdChange(variantId);
        (0,gtm/* gtm */.w)({
            group: gtm/* Gtm.GroupName.Product */.P.Df.Product,
            name: gtm/* Gtm.ProductEventName.SwitchVariant */.P.MB.SwitchVariant,
            data: {
                product: {
                    productTitle: product.title,
                    productId: product.id + "",
                    productType: product.productType,
                    tags: product.tags.join(","),
                    variantId: variantId + ""
                }
            }
        });
    }, [
        product.id,
        product.productType,
        product.tags,
        product.title,
        selectedVariantId,
        onVariantIdChange, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test": "variant-selection",
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "size",
                className: "inline-block mb-1 text-sm text-text-secondary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "pdp:buy-panel:size"
                })
            }),
            variants.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-[42px] whitespace-nowrap rounded-sm border border-grey-200 bg-other-white py-2 pl-4 pr-6 focus:outline-hidden",
                children: [
                    variants[0].title,
                    variants[0].availableForSale ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "pdp:buy-panel:out-of-stock"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(expand_more/* default */.Z, {
                        className: "absolute w-5 h-5 transform -translate-y-1/2 pointer-events-none right-3 top-1/2 text-text-secondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                        className: "h-[42px] w-full appearance-none rounded-lg border border-grey-200 bg-other-white pl-3 pr-6 text-text-secondary focus:outline-hidden",
                        id: "size",
                        value: selectedVariantId || "",
                        onBlur: onVariantChange,
                        onChange: onVariantChange,
                        children: variants.map(function(variant) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                value: variant.id,
                                children: [
                                    variant.title,
                                    variant.availableForSale ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "pdp:buy-panel:out-of-stock"
                                    })
                                ]
                            }, variant.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var variant_selector = (VariantSelector);

;// CONCATENATED MODULE: ./src/modules/product-details/components/buy-panel/index.tsx





























var AddToExistingSubscriptionButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1695).then(__webpack_require__.bind(__webpack_require__, 91695));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91695)
            ];
        }
    },
    ssr: false
});
var SubscriptionConfirmationInformation = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7523).then(__webpack_require__.bind(__webpack_require__, 75341));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75341)
            ];
        }
    },
    ssr: false
});
var CouponDisplay = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9657).then(__webpack_require__.bind(__webpack_require__, 59657));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59657)
            ];
        }
    },
    ssr: false
});
var BackInStockModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7863), __webpack_require__.e(9337), __webpack_require__.e(6606)]).then(__webpack_require__.bind(__webpack_require__, 16606));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16606)
            ];
        }
    },
    ssr: false
});
var CrossSellPDP = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4289).then(__webpack_require__.bind(__webpack_require__, 64289));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64289)
            ];
        }
    }
});
var RecommendedAlternative = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7811).then(__webpack_require__.bind(__webpack_require__, 47811));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47811)
            ];
        }
    }
});
var EtaCommunication = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 495).then(__webpack_require__.bind(__webpack_require__, 40495));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40495)
            ];
        }
    },
    ssr: false
});
var VariantSelectorTest = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 991).then(__webpack_require__.bind(__webpack_require__, 50991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50991)
            ];
        }
    },
    ssr: false
});
var OrderTypeSelectorTest = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2507).then(__webpack_require__.bind(__webpack_require__, 42507));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42507)
            ];
        }
    },
    ssr: false
});
var TinyCart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5531), __webpack_require__.e(7774)]).then(__webpack_require__.bind(__webpack_require__, 97660));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97660)
            ];
        }
    },
    ssr: false
});
var DEFAULT_SUBSCRIPTION_TYPES = [
    "Nassfutter",
    "Trockenfutter",
    "Frische-Men\xfcs",
    "Snacks", 
];
var DEFAULT_SUBSCRIPTION_ORDERS_COUNT = 2;
var BuyPanel = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), isCartAnimationOn = ref4[0], setIsCartAnimationOn = ref4[1];
    var ref5 = (0,react.useState)(false), backInStockModalVisible = ref5[0], setBackInStockModalVisible = ref5[1];
    var asPath = (0,next_router.useRouter)().asPath;
    var onAddToCart = hooks_useProductDetailsCart().onAddToCart;
    var ref6 = (0,state/* useProductDetailsHeaderState */.Xe)(), couponPrices = ref6.couponPrices, crossSellProductDetails = ref6.crossSellProductDetails, crossSellProductQuantity = ref6.crossSellProductQuantity, oneOffPrice = ref6.oneOffPrice, orderType = ref6.orderType, price = ref6.price, pricePerKilo = ref6.pricePerKilo, product = ref6.product, selectedVariant = ref6.selectedVariant, selectedVariantId = ref6.selectedVariantId, subscriptionInterval = ref6.subscriptionInterval, variantQuantity = ref6.variantQuantity, onOrderTypeChange = ref6.onOrderTypeChange, onSubscriptionIntervalChange = ref6.onSubscriptionIntervalChange, onVariantIdChange = ref6.onVariantIdChange, onVariantQuantityChange = ref6.onVariantQuantityChange;
    var isEc = (0,use_is_existing_customer/* useIsExistingCustomer */.O)().isEc;
    // Check if the product is a test product and exclude it from the add to existing subscription logic
    var isTestOosItem = product === null || product === void 0 ? void 0 : product.tags.includes("test_oos");
    var crossSellPdpFlg = (0,feature_flag/* getFeatureFlag */.O)(feature_flag/* FeatureFlag.crossSellPdp */.T.crossSellPdp);
    var subscriptionEnabled = (0,utils_product/* isSubscriptionEnabled */._l)(product.tags, product.id);
    var customer = (0,auth/* useAuth */.aC)().customer;
    var isPreorderProduct = product && product.tags.includes("Preorder");
    var isVariantAvailable = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.availableForSale;
    var ref7 = (0,context/* useContentful */.G)(), contentful = ref7.data;
    var ref8 = useProductDetailsStore(), currentOrderType = ref8.currentOrderType, hasUserChangedOrderType = ref8.hasUserChangedOrderType, setCurrentOrderType = ref8.setCurrentOrderType, setHasUserChangedOrderType = ref8.setHasUserChangedOrderType;
    (0,react.useEffect)(function() {
        if (!hasUserChangedOrderType) {
            var isIncluded = DEFAULT_SUBSCRIPTION_TYPES.includes(product.productType);
            if (!subscriptionEnabled) onOrderTypeChange(order/* OrderType.ONE_OFF */.mr.ONE_OFF);
            if (subscriptionEnabled && (!customer || (customer === null || customer === void 0 ? void 0 : customer.ordersCount) < DEFAULT_SUBSCRIPTION_ORDERS_COUNT) && isIncluded) {
                onOrderTypeChange(order/* OrderType.SUBSCRIPTION */.mr.SUBSCRIPTION);
            }
        } else if (hasUserChangedOrderType) {
            onOrderTypeChange(currentOrderType);
        }
    }, [
        currentOrderType,
        customer,
        hasUserChangedOrderType,
        product.productType,
        subscriptionEnabled,
        onOrderTypeChange, 
    ]);
    var changeOrderType = (0,react.useCallback)(function(orderType) {
        !hasUserChangedOrderType && setHasUserChangedOrderType(true);
        onOrderTypeChange(orderType);
        setCurrentOrderType(orderType);
    }, [
        hasUserChangedOrderType,
        onOrderTypeChange,
        setCurrentOrderType,
        setHasUserChangedOrderType, 
    ]);
    /**
   * We set the state to false when moving to another page and the product is not subscriable.
   * This prevents the issue of passing directly from a PDP of a product with a subscription to a PDP of a product without a subscription tag, that the interval menu remains visible.
   */ (0,react.useEffect)(function() {
        if (!subscriptionEnabled) setHasUserChangedOrderType(false);
    }, [
        asPath,
        setHasUserChangedOrderType,
        subscriptionEnabled
    ]);
    var ref9 = (0,react.useState)(false), showTinyCart = ref9[0], setShowTinyCart = ref9[1];
    var ref10 = (0,use_test_pt6874/* default */.Z)(), variantTestPT6874 = ref10.variant;
    var _onAddToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var timeoutId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onAddToCart()
                    ];
                case 1:
                    _state.sent();
                    if (variantTestPT6874 !== 0) {
                        setShowTinyCart(true);
                    }
                    setIsCartAnimationOn(true);
                    timeoutId = setTimeout(function() {
                        return setIsCartAnimationOn(false);
                    }, 6000);
                    return [
                        2,
                        function() {
                            return clearTimeout(timeoutId);
                        }
                    ];
            }
        });
    }), [
        onAddToCart,
        variantTestPT6874
    ]);
    var hasSubscription = (0,use_has_subscription/* default */.Z)().hasSubscription;
    //PT-6280: FE: AB Test display for picking sub or single purchase
    // @see https://petsdeli.atlassian.net/browse/PT-6280
    var ref11 = (0,use_experiment/* default */.Z)({
        baseEntryId: "6z115ZL0JQvAa3s6svqRIk"
    }), loadingTest6280 = ref11.loading, variantTest6280 = ref11.variant;
    //PT-6298: FE: AB Test savings for trays in variant selector on PDP
    // @see https://petsdeli.atlassian.net/browse/PT-6298
    var ref12 = (0,use_experiment/* default */.Z)({
        baseEntryId: "6Y0PTHQfJRTWGlgOiKzEFM"
    }), loadingTest6298 = ref12.loading, variantTest6298 = ref12.variant;
    var oneOffItemsInput = (0,react.useMemo)(function() {
        var input = [];
        if (crossSellProductDetails && crossSellProductQuantity > 0) {
            input.push(crossSellProductDetails);
        }
        if (orderType === "one-off" && selectedVariant) {
            input.push({
                product: product,
                quantity: variantQuantity,
                productId: product.id,
                variantId: selectedVariant.id
            });
        }
        return input.length > 0 ? input : undefined;
    }, [
        crossSellProductDetails,
        crossSellProductQuantity,
        orderType,
        selectedVariant,
        product,
        variantQuantity, 
    ]);
    var ref13 = (0,react.useState)(null), subResult = ref13[0], setSubResult = ref13[1];
    var callback = (0,react.useCallback)(function(arg) {
        setSubResult(null);
        if (arg && arg[arg.length - 1].status === "fulfilled") {
            var result = arg[arg.length - 1];
            setSubResult(result.value);
        }
    }, []);
    var selectedVariantDiscount = (0,react.useMemo)(function() {
        var ref;
        return couponPrices === null || couponPrices === void 0 ? void 0 : (ref = couponPrices.variants) === null || ref === void 0 ? void 0 : ref.find(function(v) {
            return v.id === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) + "";
        });
    }, [
        couponPrices === null || couponPrices === void 0 ? void 0 : couponPrices.variants,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    var globalDiscount = (0,common/* useCommon */.G)().globalDiscount;
    var subscriptionDiscount = ((ref1 = couponPrices === null || couponPrices === void 0 ? void 0 : (ref = couponPrices.variants) === null || ref === void 0 ? void 0 : ref.find(function(cp) {
        return cp.id === selectedVariantId + "";
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.discounts[0].value) || ((ref3 = globalDiscount.discount) === null || ref3 === void 0 ? void 0 : ref3.firstSubscriptionOrderDiscount) || config/* default.subscriptionDiscount */.Z.subscriptionDiscount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showTinyCart && /*#__PURE__*/ (0,jsx_runtime.jsx)(TinyCart, {
                onCloseCallback: function() {
                    setShowTinyCart(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rounded-lg border border-grey-200 py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("grid grid-cols-6 px-4 lg:gap-4", variantTest6298 === 1 ? "gap-4" : "gap-6"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("col-span-6", variantTest6298 === 1 ? "lg:col-span-6" : "lg:col-span-4"),
                                        children: (!loadingTest6298 || variantTest6298 !== undefined) && (variantTest6298 === 1 && selectedVariantDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantSelectorTest, {
                                            couponPrices: couponPrices,
                                            orderType: orderType,
                                            pricePerKilo: pricePerKilo,
                                            product: product,
                                            selectedVariant: selectedVariant,
                                            selectedVariantDiscount: selectedVariantDiscount,
                                            onVariantIdChange: onVariantIdChange
                                        }) : variantTest6298 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_selector, {
                                            product: product,
                                            selectedVariantId: selectedVariantId,
                                            onVariantIdChange: onVariantIdChange
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-10 animate-pulse rounded-lg bg-grey-600 opacity-40"
                                        }))
                                    }),
                                    (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.availableForSale) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("col-span-6", variantTest6298 === 1 ? "lg:col-span-6" : "lg:col-span-2"),
                                        children: [
                                            variantTest6298 !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "size",
                                                className: "mb-1 inline-block text-sm text-text-secondary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "pdp:buy-panel:amount"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                                                "data-test": "amount-input",
                                                minValue: 1,
                                                value: variantQuantity,
                                                onChange: onVariantQuantityChange,
                                                className: "min-h-[42px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.availableForSale) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-4 mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EtaCommunication, {
                                    variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
                                })
                            }),
                            subscriptionEnabled && !loadingTest6280 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-4 h-1 border-b border-dashed border-grey-200 lg:block"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-test": "subscription-option",
                                        className: "w-full grow px-4 sm:w-auto md:pt-0",
                                        children: variantTest6280 === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeSelectorTest, {
                                            couponPrices: couponPrices,
                                            selectedVariantId: selectedVariantId,
                                            interval: subscriptionInterval,
                                            orderType: orderType,
                                            onIntervalChange: onSubscriptionIntervalChange,
                                            onOrderTypeChange: changeOrderType
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(order_type_form/* default */.Z, {
                                                    subscriptionDiscount: +subscriptionDiscount,
                                                    value: orderType,
                                                    onChange: changeOrderType
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_interval_form/* default */.Z, {
                                                    couponPrices: couponPrices,
                                                    interval: subscriptionInterval,
                                                    isActive: orderType === order/* OrderType.SUBSCRIPTION */.mr.SUBSCRIPTION,
                                                    productId: product.id,
                                                    onChange: onSubscriptionIntervalChange,
                                                    subscriptionDiscount: +subscriptionDiscount
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isEc && product.availableForSale && contentful.fields.crossSellProductHandle && contentful.fields.crossSellProductVariantId && crossSellPdpFlg && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSellPDP, {
                            handle: contentful.fields.crossSellProductHandle,
                            variantId: contentful.fields.crossSellProductVariantId
                        })
                    }),
                    !product.availableForSale && contentful.fields.recommendedAlternativeProductHandle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedAlternative, {
                            productHandle: contentful.fields.recommendedAlternativeProductHandle
                        })
                    }),
                    selectedVariantDiscount && couponPrices && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDisplay, {
                        orderType: orderType,
                        couponPrices: couponPrices,
                        discountedPrice: selectedVariantDiscount,
                        className: "mb-4"
                    }),
                    selectedVariantId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shipping_element/* default */.Z, {
                                isPreorderProduct: isPreorderProduct,
                                isVariantAvailable: isVariantAvailable
                            }),
                            variantTest6298 !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1 ",
                                children: selectedVariantDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(price_element/* default */.Z, {
                                    className: "mt-2",
                                    couponPrices: couponPrices,
                                    oneOffPrice: oneOffPrice,
                                    orderType: orderType,
                                    price: price,
                                    pricePerKilo: pricePerKilo,
                                    product: product,
                                    selectedVariant: selectedVariant,
                                    hasInfoPrice: true,
                                    selectedVariantDiscount: selectedVariantDiscount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buy_button, {
                        className: "mt-4",
                        isCartAnimationOn: isCartAnimationOn,
                        onAddToCart: _onAddToCart,
                        onBackInStockClick: function() {
                            return setBackInStockModalVisible(true);
                        },
                        product: product,
                        selectedVariant: selectedVariant
                    })
                ]
            }),
            !isTestOosItem && hasSubscription && selectedVariantId && (subscriptionEnabled || oneOffItemsInput) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    customer && subResult && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionConfirmationInformation, {
                        customerId: customer.id,
                        subResult: subResult,
                        onCloseCallback: function() {
                            setSubResult(null);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToExistingSubscriptionButton, {
                            disabled: !isVariantAvailable || !product.availableForSale,
                            callback: callback,
                            orderType: orderType,
                            oneOffItemsInput: oneOffItemsInput,
                            subscriptionItemsInput: subscriptionEnabled && orderType === "subscription" ? [
                                {
                                    quantity: variantQuantity,
                                    masterProductId: product.id,
                                    masterVariantId: selectedVariantId
                                }, 
                            ] : undefined
                        })
                    })
                ]
            }),
            product && selectedVariant && !selectedVariant.availableForSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockModal, {
                isOpen: backInStockModalVisible,
                selectedVariant: selectedVariant,
                variants: product.variants,
                product: product,
                onClose: function() {
                    return setBackInStockModalVisible(false);
                }
            })
        ]
    });
};
/* harmony default export */ var buy_panel = (BuyPanel);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
;// CONCATENATED MODULE: ./src/assets/icons/search.svg
var search_path, search_g;
function search_extends() { return search_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, search_extends.apply(null, arguments); }

function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", search_extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("mask", {
    id: "search_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, search_path || (search_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))), search_g || (search_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#search_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M16.333 17.5l-5.25-5.25a5.08 5.08 0 01-3.167 1.083c-1.513 0-2.794-.524-3.843-1.573C3.024 10.712 2.5 9.43 2.5 7.917c0-1.514.524-2.795 1.573-3.844S6.403 2.5 7.917 2.5c1.514 0 2.795.524 3.843 1.573 1.049 1.049 1.573 2.33 1.573 3.844a5.08 5.08 0 01-1.083 3.166l5.25 5.25-1.167 1.167zm-8.416-5.833c1.041 0 1.927-.365 2.656-1.094.73-.73 1.094-1.615 1.094-2.656 0-1.042-.365-1.927-1.094-2.657-.73-.729-1.615-1.093-2.656-1.093-1.042 0-1.927.364-2.657 1.093-.729.73-1.093 1.615-1.093 2.657 0 1.041.364 1.927 1.093 2.656.73.73 1.615 1.094 2.657 1.094z",
    fill: "#666"
  }))));
}
/* harmony default export */ var search = (SvgSearch);
// EXTERNAL MODULE: ./src/hooks/common/use-shimmer-data-url.ts
var use_shimmer_data_url = __webpack_require__(12593);
;// CONCATENATED MODULE: ./src/hooks/product/use-synchronise-variant-image.ts


/**
 * Custom hook to synchronise variant image with product gallery slider, svg layer and the full screen gallery
 */ var useSynchoniseVariantImage = function(param) {
    var productGallery = param.productGallery, selectedGalleryItemIndex = param.selectedGalleryItemIndex, selectedVariantId = param.selectedVariantId, sliderRef = param.sliderRef, svgLayerRef = param.svgLayerRef, variants = param.variants, setSelectedGalleryItemIndex = param.setSelectedGalleryItemIndex;
    var ref = (0,next_router.useRouter)(), query = ref.query, isReady = ref.isReady;
    var ref1 = (0,react.useState)(), imageIndex = ref1[0], setImageIndex = ref1[1];
    (0,react.useEffect)(function() {
        if (!isReady) return;
        var updateImageIndex = function(index) {
            var ref;
            (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(index);
            setSelectedGalleryItemIndex(index);
            setImageIndex(index);
        };
        var newVariantId = Number(query.variant);
        if (!newVariantId) {
            updateImageIndex(0);
        } else if (newVariantId !== selectedVariantId) {
            var variant = variants.find(function(param) {
                var id = param.id;
                return id === newVariantId;
            });
            var variantImageIndex = variant ? productGallery.findIndex(function(param) {
                var imageData = param.imageData;
                return imageData && imageData.id === variant.image.id;
            }) : -1;
            if (variantImageIndex > -1) updateImageIndex(variantImageIndex);
        }
    }, [
        query,
        isReady,
        productGallery,
        selectedVariantId,
        sliderRef,
        svgLayerRef,
        variants,
        setSelectedGalleryItemIndex, 
    ]);
    (0,react.useEffect)(function() {
        var ref;
        return sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(selectedGalleryItemIndex);
    }, [
        selectedGalleryItemIndex,
        sliderRef
    ]);
    (0,react.useEffect)(function() {
        if (svgLayerRef.current === undefined && imageIndex !== undefined) {
            svgLayerRef.current = imageIndex;
        }
    });
};
/* harmony default export */ var use_synchronise_variant_image = (useSynchoniseVariantImage);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/utils/image-loader.ts
var image_loader = __webpack_require__(6213);
;// CONCATENATED MODULE: ./src/modules/product-details/components/full-screen-gallery/images-carousel.tsx





var ImagesCarousel = function(param) {
    var classNames = param.classNames, imageBackgroundColor = param.imageBackgroundColor, images = param.images, product = param.product, sliderRef = param.sliderRef, setSelectedGalleryItemIndex = param.setSelectedGalleryItemIndex;
    var blurDataURL = (0,use_shimmer_data_url/* useShimmerDataUrl */.N)({
        width: 64,
        height: 64
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: images.length !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("mt-3 hidden items-center gap-3 overflow-hidden overflow-x-scroll lg:flex", images.length <= 4 && "justify-center", classNames),
            children: images.map(function(image, index) {
                if (!image.imageData) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("h-[132px] w-[132px] shrink-0 rounded-md p-1", imageBackgroundColor),
                    onClick: function() {
                        setSelectedGalleryItemIndex(index);
                        sliderRef.current && sliderRef.current.slickGoTo(index);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image.imageData.originalSrc,
                        alt: image.imageData.altText || product.title,
                        placeholder: "blur",
                        blurDataURL: blurDataURL,
                        className: "rounded-md",
                        width: 132,
                        height: 132,
                        loader: image_loader/* generalImageLoader */.x
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var images_carousel = (ImagesCarousel);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
;// CONCATENATED MODULE: ./src/modules/product-details/components/segment-banner/index.tsx






function isHTML(str) {
    // Simple regex to check if string contains HTML tags
    var pattern = /<\/?[a-z][\s\S]*>/i;
    return typeof str === "string" && pattern.test(str);
}
/**
 * Segment banner to display best seller text based on segmentation
 * When the string, "bestseller" is present, it's rendered with bold style
 */ var SegmentBanner = function(_param) {
    var children = _param.children, className = _param.className, others = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var processedChildren;
    if (isHTML(children)) {
        processedChildren = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: children
            }
        });
    } else if (typeof children === "string") {
        // Backend returns bold tag as "** some word** "
        var formattedText = children.replace(/\*\*(.*?)\*\*/g, '<span class="font-medium">$1</span>');
        processedChildren = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: formattedText
            }
        });
    } else {
        processedChildren = children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()("relative inline-block rounded-sm bg-badge-bestseller px-2 py-[10px] text-primary-main", className)
    }, others), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-6 top-[-6px] h-4 w-4 rotate-45 rounded-xs bg-badge-bestseller"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "line-clamp-4",
                children: processedChildren
            })
        ]
    }));
};
/* harmony default export */ var segment_banner = (SegmentBanner);

;// CONCATENATED MODULE: ./src/modules/product-details/components/images-gallery-desktop/index.tsx













var ImagesGalleryDesktop = function(param) {
    var imageBackgroundColor = param.imageBackgroundColor, product = param.product, productGallery = param.productGallery, selectedGalleryItemIndex = param.selectedGalleryItemIndex, selectedVariantId = param.selectedVariantId, svgLayerRef = param.svgLayerRef, onOpenGallery = param.onOpenGallery, onSwipe = param.onSwipe, setSelectedGalleryItemIndex = param.setSelectedGalleryItemIndex, ribbonText = param.ribbonText;
    var sliderRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (sliderRef.current !== null) {
            // Slide to image
            sliderRef.current.slickGoTo(selectedGalleryItemIndex);
        }
    }, [
        selectedGalleryItemIndex
    ]);
    var sliderOptions = {
        slidesToShow: 1,
        arrows: false,
        // useCSS: true,
        autoplay: false,
        infinite: false,
        draggable: false,
        afterChange: function afterChange(index) {
            if (onSwipe) onSwipe(index);
            var videos = document.querySelectorAll("video");
            Array.from(videos).map(function(video) {
                return video.pause();
            });
            var video = document.querySelector(".slick-active video");
            if (video) {
                video.play();
            }
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    infinite: true,
                    //useCSS: true,
                    draggable: true
                }
            }, 
        ]
    };
    var blurDataURL = (0,use_shimmer_data_url/* useShimmerDataUrl */.N)({
        width: 64,
        height: 64
    });
    use_synchronise_variant_image({
        productGallery: productGallery,
        selectedGalleryItemIndex: selectedGalleryItemIndex,
        selectedVariantId: selectedVariantId,
        sliderRef: sliderRef,
        svgLayerRef: svgLayerRef,
        variants: product.variants,
        setSelectedGalleryItemIndex: setSelectedGalleryItemIndex
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("relative flex-1 rounded-lg p-4"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderOptions), {
                        ref: sliderRef,
                        children: productGallery.map(function(image, index) {
                            if (!image.imageData) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "group relative cursor-pointer",
                                onClick: function() {
                                    var ref;
                                    setSelectedGalleryItemIndex(index);
                                    (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(index);
                                    onOpenGallery(selectedGalleryItemIndex);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: image.imageData.altText || product.title,
                                    blurDataURL: blurDataURL,
                                    className: "rounded-lg",
                                    loader: image_loader/* generalImageLoader */.x,
                                    placeholder: "blur",
                                    priority: true,
                                    src: image.imageData.originalSrc,
                                    width: 400,
                                    height: 400
                                })
                            }, index);
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "absolute bottom-0 right-0 mb-3 mr-3 flex h-8 w-8 items-center justify-center rounded-full bg-grey-50",
                        onClick: function() {
                            return onOpenGallery(selectedGalleryItemIndex);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
                            className: "h-3.5 w-3.5 text-text-secondary"
                        })
                    })
                ]
            }),
            ribbonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(segment_banner, {
                children: ribbonText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(images_carousel, {
                imageBackgroundColor: imageBackgroundColor,
                images: productGallery,
                product: product,
                setSelectedGalleryItemIndex: setSelectedGalleryItemIndex,
                sliderRef: sliderRef
            })
        ]
    });
};
/* harmony default export */ var images_gallery_desktop = (ImagesGalleryDesktop);

// EXTERNAL MODULE: ./src/hooks/slider/use-prevent-horizontal-scroll.ts
var use_prevent_horizontal_scroll = __webpack_require__(22887);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var future_image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs
var motion_minimal = __webpack_require__(12560);
;// CONCATENATED MODULE: ./src/modules/product-details/components/carousel-selector/index.tsx



var CarouselSelector = function(param) {
    var images = param.images, selectedGalleryItemIndex = param.selectedGalleryItemIndex, onClick = param.onClick;
    if (images.length === 1) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center gap-[6px] lg:hidden",
        children: images.map(function(image, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.button, {
                animate: {
                    backgroundColor: selectedGalleryItemIndex === index ? "#19335A" : "#B4BDCC",
                    width: selectedGalleryItemIndex === index ? 18 : 6
                },
                className: classnames_default()("h-[6px] rounded-full focus:outline-hidden"),
                onClick: function() {
                    return onClick(index);
                },
                transition: {
                    damping: 20,
                    duration: 0.2,
                    stiffness: 500,
                    type: "spring"
                }
            }, index);
        })
    });
};
/* harmony default export */ var carousel_selector = (CarouselSelector);

;// CONCATENATED MODULE: ./src/modules/product-details/components/images-gallery-mobile/index.tsx












var ImagesGalleryMobile = function(param) {
    var selectedGalleryItemIndex = param.selectedGalleryItemIndex, productGallery = param.productGallery, selectedVariantId = param.selectedVariantId, svgLayerRef = param.svgLayerRef, variants = param.variants, onOpenGallery = param.onOpenGallery, onSwipe = param.onSwipe, setSelectedGalleryItemIndex = param.setSelectedGalleryItemIndex;
    var product = (0,state/* useProductDetailsHeaderState */.Xe)().product;
    var $slider = (0,react.useRef)(null);
    var sliderOptions = {
        arrows: false,
        autoplay: false,
        draggable: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: "0px",
        afterChange: function(index) {
            return onSwipe(index);
        }
    };
    use_synchronise_variant_image({
        productGallery: productGallery,
        selectedGalleryItemIndex: selectedGalleryItemIndex,
        selectedVariantId: selectedVariantId,
        sliderRef: $slider,
        svgLayerRef: svgLayerRef,
        variants: variants,
        setSelectedGalleryItemIndex: setSelectedGalleryItemIndex
    });
    (0,use_prevent_horizontal_scroll/* default */.Z)($slider);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-[344px]",
        "data-test": "image-section-mobile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-[322px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderOptions), {
                    ref: $slider,
                    children: product.images.map(function(image, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: "relative h-[322px] cursor-pointer px-2 outline-hidden",
                            onClick: function() {
                                var ref;
                                (ref = $slider.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(index);
                                setSelectedGalleryItemIndex(index);
                                onOpenGallery(index);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                className: "h-auto w-full rounded-lg",
                                loader: image.id === "test" ? undefined : image_loader/* generalImageLoader */.x,
                                src: image.originalSrc,
                                priority: index === 0,
                                alt: image.altText || product.title,
                                fill: true,
                                style: {
                                    objectFit: "contain"
                                }
                            })
                        }, index);
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_selector, {
                    images: product.images,
                    selectedGalleryItemIndex: selectedGalleryItemIndex,
                    onClick: function(index) {
                        var ref;
                        (ref = $slider.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(index);
                        setSelectedGalleryItemIndex(index);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "absolute bottom-0 right-0 mb-3 flex h-8 w-8 items-center justify-center rounded-full bg-grey-50",
                onClick: function() {
                    return onOpenGallery(selectedGalleryItemIndex);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
                    className: "h-5 w-5 text-text-secondary"
                })
            })
        ]
    });
};
/* harmony default export */ var images_gallery_mobile = (ImagesGalleryMobile);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
;// CONCATENATED MODULE: ./src/assets/icons/arrow-left-bold.svg
var arrow_left_bold_path;
function arrow_left_bold_extends() { return arrow_left_bold_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, arrow_left_bold_extends.apply(null, arguments); }

function SvgArrowLeftBold(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_left_bold_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_left_bold_path || (arrow_left_bold_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.53.04a1.885 1.885 0 00-.951.393c-.092.073-11.338 9.914-11.43 10a2.09 2.09 0 00-.618 1.184c-.027.151-.037.45-.02.594a2.377 2.377 0 00.65 1.364c.042.04 2.577 2.259 5.634 4.93 3.057 2.67 5.6 4.894 5.65 4.943.563.54 1.34.67 2.022.34a2.025 2.025 0 001.02-1.162c.054-.172.07-.266.075-.47a1.592 1.592 0 00-.117-.695 1.884 1.884 0 00-.465-.684 1380.87 1380.87 0 00-4.998-4.395c-2.682-2.352-4.89-4.295-4.908-4.317-.057-.07-.06-.151-.01-.222.017-.023 9.64-8.474 9.892-8.686.29-.245.468-.544.542-.907.04-.198.035-.494-.012-.714-.07-.327-.265-.716-.458-.915-.411-.424-.953-.634-1.497-.582z",
    fill: "currentColor"
  })));
}
/* harmony default export */ var arrow_left_bold = (SvgArrowLeftBold);
;// CONCATENATED MODULE: ./src/assets/icons/arrow-right-bold.svg
var arrow_right_bold_path;
function arrow_right_bold_extends() { return arrow_right_bold_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, arrow_right_bold_extends.apply(null, arguments); }

function SvgArrowRightBold(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_right_bold_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_right_bold_path || (arrow_right_bold_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.173.02c-.648.083-1.24.496-1.508 1.051-.322.666-.201 1.465.303 2 .048.05 2.286 2.021 5.011 4.413l4.925 4.322.026.062c.053.13.055.206.008.282-.01.017-2.223 1.965-4.918 4.329-2.694 2.364-4.941 4.34-4.993 4.39a1.75 1.75 0 00-.27.325c-.3.46-.366 1.027-.182 1.591.065.2.2.451.338.634.186.244.476.451.776.552l.084.029h1.004l.107-.038c.2-.072.388-.177.551-.308.042-.035 2.591-2.285 5.664-5l5.66-5.002a2.11 2.11 0 00.71-1.273c.026-.147.036-.452.02-.615-.052-.516-.271-1.029-.647-1.51C18.777 10.169 7.622.41 7.497.328a1.965 1.965 0 00-.805-.304 2.98 2.98 0 00-.52-.004z",
    fill: "currentColor"
  })));
}
/* harmony default export */ var arrow_right_bold = (SvgArrowRightBold);
// EXTERNAL MODULE: ./src/components/modal-slide-up/index.tsx
var modal_slide_up = __webpack_require__(32168);
// EXTERNAL MODULE: ./src/hooks/common/use-lock-body-scroll.ts
var use_lock_body_scroll = __webpack_require__(56238);
// EXTERNAL MODULE: ./src/utils/shopify.ts
var shopify = __webpack_require__(82610);
;// CONCATENATED MODULE: ./src/modules/product-details/components/full-screen-gallery/index.tsx













var PanZoom = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(840), __webpack_require__.e(1100)]).then(__webpack_require__.bind(__webpack_require__, 1100));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1100)
            ];
        }
    },
    ssr: false
});
var FullScreenGallery = function(props, ref) {
    var $slider = react.useRef(null);
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), open = _$ref[0], setOpen = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), zoom = _$ref1[0], setZoom = _$ref1[1];
    react.useImperativeHandle(ref, function() {
        return {
            goToIndex: function(index) {
                var _$ref;
                (_$ref = $slider.current) === null || _$ref === void 0 ? void 0 : _$ref.slickGoTo(index);
            },
            openGallery: function() {
                setOpen(true);
                setIsGalleryOpen(true);
            }
        };
    });
    var firstOpenGalleryTrackingRef = props.firstOpenGalleryTrackingRef, imageBackgroundColor = props.imageBackgroundColor, product = props.product, productGallery = props.productGallery, selectedGalleryItemIndex = props.selectedGalleryItemIndex, setSelectedGalleryItemIndex = props.setSelectedGalleryItemIndex, setIsGalleryOpen = props.setIsGalleryOpen;
    (0,use_lock_body_scroll/* default */.Z)(open);
    var onDoubleTap = react.useCallback(function() {
        (0,src_tracking/* gtm */.wT)((0,src_tracking/* zoomElement */.$w)({
            element: [
                "PDP Images"
            ]
        }));
        setZoom(zoom === 1 ? 2.5 : 1);
    }, [
        zoom
    ]);
    react.useEffect(function() {
        var handleKeyDown = function(event) {
            if (event.key === "Escape") setOpen(false);
        };
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_slide_up/* default */.Z, {
        backdropClassName: "bg-other-black/50",
        containerBackgroundColor: imageBackgroundColor,
        containerClassName: "lg:max-w-[calc(100vw-32px)] lg:max-h-[calc(100vh-32px)]",
        headerClassName: "p-0",
        onClose: function() {
            setOpen(false);
            setIsGalleryOpen(false);
            firstOpenGalleryTrackingRef.current = true;
        },
        open: open,
        swipeToClose: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "absolute left-0 z-10 ml-3 hidden h-full w-1/4 items-center opacity-0 transition-opacity hover:opacity-100 lg:flex",
                        onClick: function() {
                            var _$ref;
                            (_$ref = $slider.current) === null || _$ref === void 0 ? void 0 : _$ref.slickPrev();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left_bold, {
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "absolute right-0 z-10 mr-3 hidden h-full w-1/4 items-center justify-end opacity-0 transition-opacity hover:opacity-100 lg:flex",
                        onClick: function() {
                            var _$ref;
                            (_$ref = $slider.current) === null || _$ref === void 0 ? void 0 : _$ref.slickNext();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_bold, {
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        suppressHydrationWarning: true,
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                afterChange: function(index) {
                                    return setSelectedGalleryItemIndex(index);
                                },
                                arrows: false,
                                dots: false,
                                draggable: false,
                                initialSlide: selectedGalleryItemIndex,
                                ref: $slider,
                                swipe: false,
                                swipeToSlide: false,
                                children: productGallery.map(function(image, index) {
                                    if (!image.imageData) return null;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-[calc(100svh-104px)] flex-1 overflow-hidden lg:h-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanZoom, {
                                            zoom: zoom,
                                            onSwipeLeft: function() {
                                                var _$ref;
                                                (_$ref = $slider.current) === null || _$ref === void 0 ? void 0 : _$ref.slickNext();
                                                setZoom(1);
                                            },
                                            onSwipeRight: function() {
                                                var _$ref;
                                                (_$ref = $slider.current) === null || _$ref === void 0 ? void 0 : _$ref.slickPrev();
                                                setZoom(1);
                                            },
                                            onDoubleTap: onDoubleTap,
                                            onZoom: function(newZoom) {
                                                (0,src_tracking/* gtm */.wT)((0,src_tracking/* zoomElement */.$w)({
                                                    element: [
                                                        "PDP Images"
                                                    ]
                                                }));
                                                setZoom(newZoom);
                                            },
                                            children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                loading: "lazy",
                                                src: (0,shopify/* getShopifyImageUrl */.RF)(image.imageData.originalSrc, 1600, 1600),
                                                alt: image.imageData.altText || product.title,
                                                className: "h-[calc(100svh-104px)] w-full object-contain object-center lg:h-[calc(100vh-272px)]"
                                            }) : null
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_selector, {
                                images: product.images,
                                selectedGalleryItemIndex: selectedGalleryItemIndex,
                                onClick: function(index) {
                                    var _$ref;
                                    (_$ref = $slider.current) === null || _$ref === void 0 ? void 0 : _$ref.slickGoTo(index);
                                    setZoom(1);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_carousel, {
                    classNames: "bg-other-white -mx-3 -mb-6 rounded-b-lg p-4",
                    imageBackgroundColor: imageBackgroundColor,
                    images: productGallery,
                    product: product,
                    setSelectedGalleryItemIndex: setSelectedGalleryItemIndex,
                    sliderRef: $slider
                })
            })
        ]
    });
};
/* harmony default export */ var full_screen_gallery = (/*#__PURE__*/react.forwardRef(FullScreenGallery));

// EXTERNAL MODULE: ./src/components/judge-me-preview-badge/index.tsx
var judge_me_preview_badge = __webpack_require__(42657);
// EXTERNAL MODULE: ./src/hooks/common/use-is-client.tsx
var use_is_client = __webpack_require__(7231);
;// CONCATENATED MODULE: ./src/modules/product-details/components/judge-me-review-badge-wrapper/index.tsx



/**
 * Wrapper component for JudgeMePreviewBadge with click event attached
 */ var JudgeMeReviewBadgeWrapper = function(param) {
    var product = param.product;
    var isClient = (0,use_is_client/* default */.Z)().isClient;
    var handleJudgeMeClick = function() {
        var element = document.querySelector(".jdgm-widget");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    if (!isClient) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(judge_me_preview_badge/* default */.Z, {
            onClick: handleJudgeMeClick,
            productId: product.id,
            numberDisplayType: "number"
        })
    });
};
/* harmony default export */ var judge_me_review_badge_wrapper = (JudgeMeReviewBadgeWrapper);

;// CONCATENATED MODULE: ./src/modules/product-details/components/product-tags/index.tsx


var ProductTags = function(param) {
    var tags = param.tags;
    if (!tags) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tags.map(function(tag, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: classnames_default()(" text-sm  leading-3 text-primary-main", tags.length - 1 !== index && "border-r border-other-black pr-2"),
                children: tag
            }, tag);
        })
    });
};
/* harmony default export */ var product_tags = (ProductTags);

// EXTERNAL MODULE: ./src/modules/product-details/pdp.module.css
var pdp_module = __webpack_require__(33863);
var pdp_module_default = /*#__PURE__*/__webpack_require__.n(pdp_module);
// EXTERNAL MODULE: ./src/components/html/index.tsx
var html = __webpack_require__(22478);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
;// CONCATENATED MODULE: ./src/modules/product-details/components/usps/utils/renderDocuments/index.tsx




/**
 * Render a rich text document from Contentful and it overrides the title if specified
 */ var renderDocument = function(param) {
    var richTextDocument = param.richTextDocument, uspTitle = param.uspTitle;
    var _obj;
    var renderOptions = {
        renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_1, function(node, children) {
            if (uspTitle) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: uspTitle
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_2, function(node, children) {
            if (uspTitle) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: uspTitle
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_3, function(node, children) {
            if (uspTitle) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: uspTitle
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: children
            });
        }), _obj)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(richTextDocument, renderOptions)
    });
};
/* harmony default export */ var renderDocuments = (renderDocument);

;// CONCATENATED MODULE: ./src/modules/product-details/components/usps/usps-view.tsx




var UspsView = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var classNames = param.classNames, content = param.content, dataTest = param.dataTest, uspTitle = param.uspTitle;
    if (typeof content === "string") {
        // Sometimes the content  contains empty list items and p tag, which renders a empty bullet point,
        // this regex removes the empty list items
        var cleanedContent = content.replace(/<li>\s*<\/li>|<p>\s*<\/p>/g, "");
        if (uspTitle) {
            cleanedContent = cleanedContent.replace(/<\/?h[34]>.*?<\/h[34]>/g, "");
        }
        if (uspTitle) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classNames,
                ref: ref,
                children: [
                    uspTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: uspTitle
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(html/* default */.Z, {
                        "data-test": dataTest,
                        children: cleanedContent
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(html/* default */.Z, {
                "data-test": dataTest,
                className: classNames,
                ref: ref,
                children: cleanedContent
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test": dataTest,
        className: classNames,
        ref: ref,
        children: renderDocuments({
            richTextDocument: content,
            uspTitle: uspTitle
        })
    });
});
UspsView.displayName = "UspsView";
/* harmony default export */ var usps_view = (UspsView);

;// CONCATENATED MODULE: ./src/modules/product-details/components/usps/utils.ts
var resolveSegmentUsps = function(segmentation, segmentId) {
    var productSegmentData = segmentation[segmentId];
    if (!productSegmentData) {
        return null;
    }
    var usps = productSegmentData.usps;
    if (usps) return usps;
    return null;
};

;// CONCATENATED MODULE: ./src/modules/product-details/components/usps/index.tsx










var Usps = function(param) {
    var defaultContent = param.defaultContent, segmentation = param.segmentation, uspTitle = param.uspTitle;
    var isClient = (0,use_is_client/* default */.Z)().isClient;
    var isMobile = (0,use_mobile/* default */.Z)();
    var ref = (0,contexts_segmentation/* useSegmentationContext */.M)(), segmentId = ref.segmentation, shouldOmitPersonalization = ref.shouldOmitPersonalization;
    var dataTestValue = isMobile ? "pdp-bullets-mob" : "product-bullets";
    var content = (0,react.useMemo)(function() {
        if (!segmentation || !segmentId || shouldOmitPersonalization) return defaultContent;
        var segmentUsps = resolveSegmentUsps(segmentation, segmentId);
        return segmentUsps !== null && segmentUsps !== void 0 ? segmentUsps : defaultContent;
    }, [
        defaultContent,
        segmentation,
        segmentId,
        shouldOmitPersonalization
    ]);
    if (!isClient) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_impression_tracker/* default */.Z, {
        element: "PDP USPs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(usps_view, {
            content: content,
            classNames: classnames_default()((pdp_module_default()).customList, "mt-5 text-sm lg:mb-0"),
            dataTest: dataTestValue,
            uspTitle: uspTitle
        })
    });
};
/* harmony default export */ var usps = (Usps);

;// CONCATENATED MODULE: ./src/modules/product-details/components/product-details-header/index.tsx

























var IncludedProducts = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5451).then(__webpack_require__.bind(__webpack_require__, 95451));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95451)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(animated_spinner/* default */.Z, {
            className: "h-6 w-6 text-text-dark-bg-contrast-white"
        });
    }
});
var AiBotTest = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9403).then(__webpack_require__.bind(__webpack_require__, 99403));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99403)
            ];
        }
    }
});
var ProductDetailsHeader = function(param) {
    var _displayAsSection = param.displayAsSection, displayAsSection = _displayAsSection === void 0 ? false : _displayAsSection;
    var ref = (0,context/* useContentful */.G)(), contentful = ref.data;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,use_mobile/* default */.Z)();
    var $gallery = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), selectedGalleryItemIndex = ref1[0], setSelectedGalleryItemIndex = ref1[1];
    // Since the first scroll happens when we sync the first image to show with the vairants,
    // we don't want to track that as a scroll event
    var firstRenderingTrackingRef = (0,react.useRef)(true);
    var firstOpenGalleryTrackingRef = (0,react.useRef)(true);
    var ref2 = (0,react.useState)(false), isGalleryOpen = ref2[0], setIsGalleryOpen = ref2[1];
    var ref3 = (0,state/* useProductDetailsHeaderState */.Xe)(), product = ref3.product, productSegmentation = ref3.productSegmentation, selectedVariantId = ref3.selectedVariantId, includedProducts = ref3.includedProducts, isProductSegmentLoading = ref3.isProductSegmentLoading;
    var lastSegmentation = (0,contexts_segmentation/* useSegmentationContext */.M)().lastSegmentation;
    var description = (0,react.useMemo)(function() {
        var ref;
        var usps = (ref = contentful.fields.header) === null || ref === void 0 ? void 0 : ref.find(function(headerEntry) {
            return headerEntry.fields.productUsp;
        });
        return usps ? usps.fields.text : undefined;
    }, [
        contentful
    ]);
    var ref4 = (0,use_breadcrumbs/* useBreadcrumbs */.h)({
        product: product
    }), breadcrumbList = ref4.breadcrumbList, isLoading = ref4.isLoading;
    var images = product.images;
    var svgLayerRef = (0,react.useRef)();
    var onOpenGallery = function(index) {
        var ref, ref1;
        (0,src_tracking/* gtm */.wT)((0,src_tracking/* selectElement */.G7)({
            element: [
                "PDP Images",
                "Open"
            ]
        }));
        (ref = $gallery.current) === null || ref === void 0 ? void 0 : ref.goToIndex(index);
        (ref1 = $gallery.current) === null || ref1 === void 0 ? void 0 : ref1.openGallery();
    };
    var productGallery = (0,react.useMemo)(function() {
        var galleryItems = [];
        images.map(function(image) {
            return galleryItems.push({
                type: "image",
                imageData: image
            });
        });
        return galleryItems;
    }, [
        images
    ]);
    (0,react.useEffect)(function() {
        setIsGalleryOpen(false);
        if (!firstRenderingTrackingRef.current) {
            firstRenderingTrackingRef.current = true;
        }
        firstOpenGalleryTrackingRef.current = true;
    }, [
        router
    ]);
    var ribbonText = (0,react.useMemo)(function() {
        try {
            return productSegmentation && (0,api_product/* isNewProductSegmentation */.eo)(productSegmentation) ? productSegmentation.recommendation_text : productSegmentation && lastSegmentation && productSegmentation.segmentation[lastSegmentation].content;
        } catch (error) {
            console.log({
                error: error
            });
            return null;
        }
    }, [
        lastSegmentation,
        productSegmentation
    ]);
    var uspTitle = (0,react.useMemo)(function() {
        if (productSegmentation && (0,api_product/* isNewProductSegmentation */.eo)(productSegmentation)) {
            return productSegmentation.usp_title;
        }
        return null;
    }, [
        productSegmentation
    ]);
    var tags = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(product.metadata.accentuate.ribbonText1 ? [
            {
                text: product.metadata.accentuate.ribbonText1,
                color: product.metadata.accentuate.ribbonColor
            }, 
        ] : []);
    }, [
        product.metadata.accentuate.ribbonColor,
        product.metadata.accentuate.ribbonText1, 
    ]);
    // FE :: AB Test - PDP AI Bot engagement test
    // @see https://petsdeli.atlassian.net/browse/PT-6961
    var ref5 = (0,use_experiment/* default */.Z)({
        baseEntryId: "1Li4be2nQvWINDQPCzzBsl"
    }), variant = ref5.variant, loading = ref5.loading;
    var productInfo = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(judge_me_review_badge_wrapper, {
                    product: product
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "mb-3 align-middle font-mindset text-2xl leading-[35.2px] text-text-primary lg:text-[32px]",
                    children: product.metadata.accentuate.mainTitle || product.title
                }),
                tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-5 mt-3 flex flex-row flex-wrap gap-2 ",
                    children: tags.map(function(v) {
                        if (typeof v === "string") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_tags, {
                                tags: [
                                    v
                                ]
                            }, v);
                        } else {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                                type: v.color,
                                children: v.text
                            }, v.text);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(buy_panel, {}),
                isMobile && !loading && variant === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AiBotTest, {}),
                description && !isProductSegmentLoading && !displayAsSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(usps, {
                    defaultContent: description,
                    uspTitle: uspTitle
                })
            ]
        });
    }, [
        displayAsSection,
        description,
        isMobile,
        isProductSegmentLoading,
        loading,
        product,
        tags,
        uspTitle,
        variant, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_gallery, {
                firstOpenGalleryTrackingRef: firstOpenGalleryTrackingRef,
                product: product,
                productGallery: productGallery,
                ref: $gallery,
                selectedGalleryItemIndex: selectedGalleryItemIndex,
                setIsGalleryOpen: setIsGalleryOpen,
                setSelectedGalleryItemIndex: setSelectedGalleryItemIndex
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container hidden lg:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs/* default */.Z, {
                        breadcrumbs: breadcrumbList,
                        dataTest: "breadcrumbs-pdp",
                        isLoading: isLoading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-12 gap-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-test": "image-section",
                                className: "col-span-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_desktop, {
                                        onOpenGallery: function(index) {
                                            return onOpenGallery(index);
                                        },
                                        onSwipe: function(index) {
                                            var ref;
                                            (ref = $gallery.current) === null || ref === void 0 ? void 0 : ref.goToIndex(index);
                                        },
                                        product: product,
                                        productGallery: productGallery,
                                        selectedGalleryItemIndex: selectedGalleryItemIndex,
                                        selectedVariantId: selectedVariantId,
                                        setSelectedGalleryItemIndex: setSelectedGalleryItemIndex,
                                        svgLayerRef: svgLayerRef,
                                        ribbonText: isProductSegmentLoading ? null : ribbonText
                                    }),
                                    !isMobile && !loading && variant === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AiBotTest, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-5",
                                "data-test": "pdp-title-block",
                                children: productInfo
                            })
                        ]
                    }),
                    product && includedProducts && includedProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IncludedProducts, {
                        product: product,
                        includedProducts: includedProducts
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs/* default */.Z, {
                breadcrumbs: breadcrumbList,
                className: "px-4 lg:hidden",
                dataTest: "breadcrumbs-pdp",
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("px-4 lg:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_mobile, {
                        onOpenGallery: function(index) {
                            return onOpenGallery(index);
                        },
                        onSwipe: function(index) {
                            var ref;
                            if (isGalleryOpen) {
                                if (!firstOpenGalleryTrackingRef.current) {
                                    (0,src_tracking/* gtm */.wT)((0,src_tracking/* scrollElement */.qR)({
                                        element: [
                                            "PDP Images"
                                        ]
                                    }));
                                } else {
                                    firstOpenGalleryTrackingRef.current = false;
                                }
                            } else {
                                if (!firstRenderingTrackingRef.current) {
                                    (0,src_tracking/* gtm */.wT)((0,src_tracking/* scrollElement */.qR)({
                                        element: [
                                            "PDP Images"
                                        ]
                                    }));
                                } else {
                                    firstRenderingTrackingRef.current = false;
                                }
                            }
                            (ref = $gallery.current) === null || ref === void 0 ? void 0 : ref.goToIndex(index);
                            setSelectedGalleryItemIndex(index);
                        },
                        productGallery: productGallery,
                        selectedGalleryItemIndex: selectedGalleryItemIndex,
                        selectedVariantId: selectedVariantId,
                        setSelectedGalleryItemIndex: setSelectedGalleryItemIndex,
                        svgLayerIndex: svgLayerRef.current,
                        svgLayerRef: svgLayerRef,
                        variants: product.variants
                    }),
                    !isProductSegmentLoading && ribbonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(segment_banner, {
                        className: "mt-2",
                        children: ribbonText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mx-4 rounded-t-[24px] bg-other-white px-4 pt-2",
                        children: productInfo
                    }),
                    product && includedProducts && includedProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IncludedProducts, {
                        product: product,
                        includedProducts: includedProducts
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var product_details_header = (ProductDetailsHeader);


/***/ }),

/***/ 724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OJ": function() { return /* binding */ ProductDetailsHeaderProvider; },
/* harmony export */   "Xe": function() { return /* binding */ useProductDetailsHeaderState; }
/* harmony export */ });
/* unused harmony export ProductDetailsHeaderContext */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ninetailed_experience_js_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30941);
/* harmony import */ var api_middleware_laggy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39143);
/* harmony import */ var api_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94070);
/* harmony import */ var constants_order__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7209);
/* harmony import */ var constants_test_dynamic_ux_test_url_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61316);
/* harmony import */ var contexts_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15731);
/* harmony import */ var contexts_ninetailed_ab_test__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84947);
/* harmony import */ var contexts_pet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75556);
/* harmony import */ var contexts_pet_profile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90018);
/* harmony import */ var contexts_segmentation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42067);
/* harmony import */ var contexts_special_ab_test_provider__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77460);
/* harmony import */ var hooks_common_use_experiment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30926);
/* harmony import */ var hooks_product_use_personalized_product_details__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97258);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8100);
/* harmony import */ var utils_toasts__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59272);






















var ProductDetailsHeaderContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_16__.createContext({});
/**
 * @TODO : We should streamline How default variant ID is selected since it's unclear.
 */ var ProductDetailsHeaderProvider = function(param) {
    var children = param.children, productDetails = param.productDetails, initialVariantId = param.initialVariantId, _interval = param.interval, interval = _interval === void 0 ? "one-off" : _interval, defaultPriceVariants = param.defaultPriceVariants;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)();
    // PT-5429: FE: Display discounted price on PDP when coupon code is applied in cart.
    // @see: https://petsdeli.atlassian.net/browse/PT-5429
    (0,hooks_common_use_experiment__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        baseEntryId: "2YR6EsyBVFAKqh7OEANfwE",
        shouldAddToHeader: true
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(null), crossSellProductDetails = ref[0], setCrossSellProductDetails = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(0), crossSellProductQuantity = ref1[0], setCrossSellProductQuantity = ref1[1];
    var testData = (0,contexts_special_ab_test_provider__WEBPACK_IMPORTED_MODULE_11__/* .useSpecialAbTestContext */ .v)().testData;
    var hideVariantsFn = (0,react__WEBPACK_IMPORTED_MODULE_16__.useCallback)(function(product, variantsToHide) {
        product.variants = product.variants.filter(function(variant) {
            return !variantsToHide.includes(variant.id);
        });
    }, []);
    var data = (0,swr__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP)(function() {
        return productDetails.product.handle;
    }, api_product__WEBPACK_IMPORTED_MODULE_3__/* .fetchProductDetails */ .g3, {
        fallback: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, productDetails.product.handle, productDetails),
        use: [
            api_middleware_laggy__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        ],
        // Revalidation is done in useOptimizeInterceptor time-aligned with audience header strings
        revalidateOnMount: false
    }).data;
    if ((testData === null || testData === void 0 ? void 0 : testData.hideVariants) && data) hideVariantsFn(data.product, testData.hideVariants);
    // at this point most of the cases, data is not undefined as we specify fallback data from static props
    var product = data.product, _includedProducts = data.includedProducts;
    var isSubscriptionInterval = interval && interval !== "one-off" && Object.values(constants_order__WEBPACK_IMPORTED_MODULE_4__/* .SubscriptionInterval */ .CE).includes(interval);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(isSubscriptionInterval ? constants_order__WEBPACK_IMPORTED_MODULE_4__/* .OrderType.SUBSCRIPTION */ .mr.SUBSCRIPTION : constants_order__WEBPACK_IMPORTED_MODULE_4__/* .OrderType.ONE_OFF */ .mr.ONE_OFF), orderType = ref2[0], setOrderType = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(1), variantQuantity = ref3[0], setVariantQuantity = ref3[1];
    var isInitialVariantIdAvailable = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        return productDetails.product.variants.some(function(variant) {
            return variant.id === initialVariantId;
        });
    }, [
        productDetails.product.variants,
        initialVariantId
    ]);
    /** Set up defaultVariantId */ var defaultVariantId = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var ref;
        if (testData === null || testData === void 0 ? void 0 : testData.hideVariants) hideVariantsFn(productDetails.product, testData.hideVariants);
        var firstAvailableCheapestVariant = productDetails.product.variants.filter(function(variant) {
            return variant.availableForSale;
        }).sort(function(a, b) {
            return +a.priceV2.amount - +b.priceV2.amount;
        })[0];
        if (initialVariantId && isInitialVariantIdAvailable) {
            return initialVariantId;
        } else if (firstAvailableCheapestVariant) {
            return firstAvailableCheapestVariant === null || firstAvailableCheapestVariant === void 0 ? void 0 : firstAvailableCheapestVariant.id;
        } else return (ref = productDetails.product.variants[0]) === null || ref === void 0 ? void 0 : ref.id;
    }, [
        testData === null || testData === void 0 ? void 0 : testData.hideVariants,
        hideVariantsFn,
        productDetails.product,
        initialVariantId,
        isInitialVariantIdAvailable, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_16__.useEffect)(function() {
        if (!isInitialVariantIdAvailable && initialVariantId) {
            router.push("/products/".concat(product.handle, "?variant=").concat(defaultVariantId));
            (0,utils_toasts__WEBPACK_IMPORTED_MODULE_18__/* .showErrorToast */ .Eo)({
                error: "error:products:product-not-available",
                caller: "ProductDetailsHeaderProvider"
            });
        }
    }, [
        defaultVariantId,
        initialVariantId,
        isInitialVariantIdAvailable,
        product,
        router, 
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(defaultVariantId), selectedVariantId = ref4[0], setSelectedVariantId = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_16__.useEffect)(function() {
        setSelectedVariantId(defaultVariantId);
    }, [
        product,
        defaultVariantId
    ]);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(isSubscriptionInterval ? interval : constants_order__WEBPACK_IMPORTED_MODULE_4__/* .SubscriptionInterval.FOUR_WEEKS */ .CE.FOUR_WEEKS), subscriptionInterval = ref5[0], setSubscriptionInterval = ref5[1];
    var selectedVariant = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        return product && product.variants.find(function(param) {
            var id = param.id;
            return id === selectedVariantId;
        });
    }, [
        selectedVariantId,
        product
    ]);
    var isInit = (0,react__WEBPACK_IMPORTED_MODULE_16__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_16__.useEffect)(function() {
        if (!isInit.current) {
            setSelectedVariantId(defaultVariantId);
        }
        isInit.current = false;
    }, [
        defaultVariantId
    ]);
    var debouncedRouterReplace = (0,react__WEBPACK_IMPORTED_MODULE_16__.useRef)(lodash_debounce__WEBPACK_IMPORTED_MODULE_14___default()(function(newVariantId, router, product, setSelectedVariantId) {
        router.replace({
            pathname: router.pathname,
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, router.query), {
                handle: product.handle,
                variant: newVariantId
            })
        }, undefined, {
            shallow: true,
            scroll: false
        }).then(function() {
            return setSelectedVariantId(newVariantId);
        });
    }, 300));
    var onVariantIdChange = (0,react__WEBPACK_IMPORTED_MODULE_16__.useCallback)(function(newVariantId) {
        debouncedRouterReplace.current(newVariantId, router, product, setSelectedVariantId);
    }, [
        router,
        product,
        setSelectedVariantId
    ]);
    var onVariantQuantityChange = (0,react__WEBPACK_IMPORTED_MODULE_16__.useCallback)(function(newQuantity) {
        if (!selectedVariantId) return;
        setVariantQuantity(newQuantity);
    }, [
        selectedVariantId
    ]);
    var multipleSegmentation = (0,contexts_segmentation__WEBPACK_IMPORTED_MODULE_10__/* .useSegmentationContext */ .M)().multipleSegmentation;
    var couponCode = (0,contexts_cart__WEBPACK_IMPORTED_MODULE_6__/* .useCart */ .j)().couponCode;
    var experimentHeaderStr = (0,contexts_ninetailed_ab_test__WEBPACK_IMPORTED_MODULE_7__/* .useNinetailedAbTestContext */ .R)().experimentHeaderStr;
    var profile = (0,_ninetailed_experience_js_next__WEBPACK_IMPORTED_MODULE_1__/* .useProfile */ .Un)().profile;
    var ref6 = (0,contexts_pet__WEBPACK_IMPORTED_MODULE_8__/* .usePetContext */ .w)(), currentPetType = ref6.current;
    var ref7 = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)(), query = ref7.query, isReady = ref7.isReady;
    var multiSegmentMode = query[constants_test_dynamic_ux_test_url_query__WEBPACK_IMPORTED_MODULE_5__/* .UrlQuery.multiSegmentMode */ .e.multiSegmentMode];
    var petProfile = (0,contexts_pet_profile__WEBPACK_IMPORTED_MODULE_9__/* .usePetProfile */ .Z)().petProfile;
    var ref8 = (0,hooks_product_use_personalized_product_details__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        petProfile: petProfile,
        segmentation: multipleSegmentation,
        productId: productDetails.product.id + "",
        couponCode: couponCode,
        defaultPriceVariants: defaultPriceVariants,
        ninetailed: experimentHeaderStr === null || experimentHeaderStr === void 0 ? void 0 : experimentHeaderStr.split(","),
        audiences: profile === null || profile === void 0 ? void 0 : profile.audiences,
        isReady: isReady,
        multiSegmentMode: !!multiSegmentMode,
        currentPetType: currentPetType
    }), personalizedProductDetails = ref8.personalizedProductDetails, isLoading = ref8.isLoading;
    var _productSegmentation = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        if (!(0,hooks_product_use_personalized_product_details__WEBPACK_IMPORTED_MODULE_13__/* .isPartialOutput */ .F)(personalizedProductDetails)) {
            return personalizedProductDetails;
        }
        return null;
    }, [
        personalizedProductDetails
    ]);
    var includedProducts = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var index = product.variants.findIndex(function(param) {
            var id = param.id;
            return id === selectedVariantId;
        });
        if (index === -1) {
            return undefined;
        }
        return _includedProducts[index];
    }, [
        product,
        _includedProducts,
        selectedVariantId
    ]);
    var prices = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var ref, ref1, ref2;
        var variant = personalizedProductDetails === null || personalizedProductDetails === void 0 ? void 0 : (ref = personalizedProductDetails.variants) === null || ref === void 0 ? void 0 : ref.find(function(v) {
            return v.id === selectedVariantId + "";
        });
        var oneOffPrice = Number(((ref1 = variant === null || variant === void 0 ? void 0 : variant.one_off.compare) === null || ref1 === void 0 ? void 0 : ref1.after) || (variant === null || variant === void 0 ? void 0 : variant.one_off.price) || 0);
        var subscriptionPrice = Number((variant === null || variant === void 0 ? void 0 : (ref2 = variant.subscription) === null || ref2 === void 0 ? void 0 : ref2.compare.after) || 0);
        var productWeight = selectedVariant && (selectedVariant.weightUnit === "GRAMS" ? selectedVariant.weight / 1000 : selectedVariant.weight);
        var pricePerKilo = (orderType === constants_order__WEBPACK_IMPORTED_MODULE_4__/* .OrderType.SUBSCRIPTION */ .mr.SUBSCRIPTION ? subscriptionPrice : oneOffPrice) / (productWeight || 1);
        return {
            oneOffPrice: oneOffPrice,
            subscriptionPrice: subscriptionPrice,
            pricePerKilo: pricePerKilo
        };
    }, [
        orderType,
        personalizedProductDetails === null || personalizedProductDetails === void 0 ? void 0 : personalizedProductDetails.variants,
        selectedVariant,
        selectedVariantId, 
    ]);
    var couponPrices = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var coupon = null;
        if (personalizedProductDetails && !(0,hooks_product_use_personalized_product_details__WEBPACK_IMPORTED_MODULE_13__/* .isPartialOutput */ .F)(personalizedProductDetails) && personalizedProductDetails.coupon) {
            coupon = personalizedProductDetails.coupon;
        }
        return {
            variants: (personalizedProductDetails === null || personalizedProductDetails === void 0 ? void 0 : personalizedProductDetails.variants) || [],
            coupon: coupon
        };
    }, [
        personalizedProductDetails
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductDetailsHeaderContext.Provider, {
        value: {
            couponPrices: couponPrices,
            crossSellProductDetails: crossSellProductDetails,
            crossSellProductQuantity: crossSellProductQuantity,
            includedProducts: includedProducts,
            oneOffPrice: prices.oneOffPrice,
            orderType: orderType,
            price: prices.subscriptionPrice,
            pricePerKilo: prices.pricePerKilo,
            product: product,
            productSegmentation: _productSegmentation,
            isProductSegmentLoading: isLoading,
            selectedVariant: selectedVariant,
            selectedVariantId: selectedVariantId,
            subscriptionInterval: subscriptionInterval,
            variantQuantity: variantQuantity,
            onOrderTypeChange: setOrderType,
            onSubscriptionIntervalChange: setSubscriptionInterval,
            onVariantIdChange: onVariantIdChange,
            onVariantQuantityChange: onVariantQuantityChange,
            setCrossSellProductDetails: setCrossSellProductDetails,
            setCrossSellProductQuantity: setCrossSellProductQuantity
        },
        children: children
    });
};
var useProductDetailsHeaderState = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_16__.useContext)(ProductDetailsHeaderContext);
};


/***/ }),

/***/ 82610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RF": function() { return /* binding */ getShopifyImageUrl; },
/* harmony export */   "kK": function() { return /* binding */ generateVariantUrl; }
/* harmony export */ });
/* unused harmony exports isCheckoutCreateMutation, normalizeShopifyResponse, shopifyGid, shopifyGidToId */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80969);

/**
 * Assert function for CheckoutCreateMutation
 */ function isCheckoutCreateMutation(arg) {
    if (typeof arg === "object" && !!arg && "checkoutCreate" in arg) {
        return true;
    }
    return false;
}
var normalizeShopifyResponse = function(data) {
    if (typeof data !== "object" || data === null) {
        return data;
    }
    if ("edges" in data) {
        return data.edges.map(function(param) {
            var node = param.node;
            return normalizeShopifyResponse(node);
        });
    }
    if (Array.isArray(data)) {
        return data.map(normalizeShopifyResponse);
    }
    return Object.keys(data).reduce(function(result, key) {
        if (key === "__typename") {
            return result;
        }
        result[key] = normalizeShopifyResponse(data[key]);
        return result;
    }, {});
};
/**
 * Convert product id or variant id into Shopify format.
 * used to make requests to Shopify graphql endpoint.
 * @example : "gid://shopify/Product/10079785100"
 * @see : https://shopify.dev/api/storefront/2023-04/scalars/ID
 */ var shopifyGid = function(namespace, id) {
    return "gid://shopify/".concat(namespace, "/").concat(id);
};
/**
 * Retrieve product id or variant id from Shopify format.
 * used to make requests to Petsdeli backend
 * @example : "10079785100"
 */ var shopifyGidToId = function(gid) {
    try {
        var matched = gid.match(RegExp(".*\\/(?<id>.+?)(\\?|$)"));
        if (!matched) {
            throw new Error("Not correct Shopify Id");
        }
        var id = matched.groups.id;
        return Number(id);
    } catch (error) {
        console.error(error);
        return 0;
    }
};
var generateVariantUrl = function(product, variant) {
    return "".concat(product.onlineStoreUrl, "?variant=").concat(variant.id);
};
var getShopifyImageUrl = function(url, width, height) {
    if (!width && !height) {
        return url;
    }
    var dimensionts = "".concat(width || "", "x").concat(height || "");
    var match = url.match(/(.*)(\.\w+)(.*)/);
    if (match) {
        var _match = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(match, 4), part1 = _match[1], extension = _match[2], part2 = _match[3];
        return "".concat(part1, "_").concat(dimensionts).concat(extension).concat(part2);
    }
    return url;
};


/***/ }),

/***/ 93000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dot":"benefits_dot__UbwuB"};

/***/ }),

/***/ 33863:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customList":"pdp_customList__B5CeT"};

/***/ })

}]);